
import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from "react-dom";
import CardPayment from './CardPayment'
import QRCode from "react-qr-code";
import { Tabs, Tab } from 'react-bootstrap';

import { FilterOrderFetchAPI } from '../../api/Paymentpost/FilterOrder';
import { PaymentMethodFetchAPI } from '../../api/Paymentpost/PaymentMethod';
import { AuthDgiFetchAPI } from '../../api/Paymentpost/AuthDgi';
import { RequestLocalFetchAPI } from '../../api/Paymentpost/RequestLocal';
import { ReservationFetchAPI } from '../../api/reservation';
import { PrintOrderLocalFetchAPI } from '../../api/Paymentpost/PrintOrder';
import { OrderNumberFetchAPI } from '../../api/Paymentpost/OrderNumber';
import { CashTempPosFetchAPI } from '../../api/Paymentpost/OrderTemporalCash';
import { CategriesPosFetchAPI } from '../../api/Paymentpost/CategoriesPos';
import { DeletedTempOrdersFetchAPI } from '../../api/DeletedTemporalOrders';
import { ClientsFetchAPI } from '../../api/Clients';
import { YappyFetchAPI } from '../../api/Paymentpost/Yappy'
import ModalPhoneSaveYappy from './ModalPhoneSaveYappy';
import Modal from 'react-bootstrap/Modal'
import ModalConfirmation from './ModalConfirmation';
import ModuleLocator from './ModuleLocator';
import ModalPaymentMixto from './ModalPaymentMixto';
import ModalPaymentManual from './ModalPaymentManual';
import ModalYappyQrPos from './ModalYappyQrPos';
import Modalclient from './ModalClients';
import ModuleTips from './ModuleTips';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import ErrorAlert from '../Alerts/ErrorAlert';
import AlertSmall from '../Alerts/AlertSmall';
import LoadingAlert from '../Alerts/LoadingAlert';
import ConfirmationAlert from '../Alerts/ConfirmationAlert';
import { PreOrderFetchAPI } from '../../api/Paymentpost/PreOrder';
import Cashierpost from '../cahsier/Cashierpost';
import { MachinesFetchAPI } from '../../api/Machines';
import { PrinterFetchAPI } from '../../api/Printer';
import { MicrosFetchAPI } from '../../api/Micros';
import { OrdersFetchAPI } from "../../api/Orders"
import { InventoryFechtAPI } from '../../api/Inventory';
import { RequestAlohaFetchAPI } from '../../api/Paymentpost/RequestAloha';
import { DeliveryOrdersFetchAPI } from '../../api/DeliveryOrders';
import { TableSessionsFetchAPI } from '../../api/TableSessions';
import moment from 'moment-timezone';

import printOrderData from './PrintOrderData';
import ModalCallCenter from './ModalCallCenter';
import payOnline from "./img/Payonline.png"
import ModalDonlee from './ModalDonlee';
import ClientPillCard from '../ClientPillCard/ClientPillCard';
import RecoveryOrderApproved from './RecoveryOrderApproved';

import ModalWaiters from './ModalWaiters';
//Sweet alert
import Swal from "sweetalert2";

//Img
import empty_img from './img/empty_pays.png';
import checkimg from './img/check.png';
import cancel from './img/cancel.png'
import sadImg from './img/sad.png'
import loading from './img/loading.gif'
//Icons 
import { FaCcVisa, FaPhoneAlt } from 'react-icons/fa';
import SuccessAlert from '../Alerts/SuccessAlert';
//Utils
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';
import { generateToken } from '../../utils/GenerateToken';
import { RenderIf } from '../utils/RenderIf';
import Socket from '../utils/Socket.config';
import { ProcessPayment } from '../../utils/ProcessPayment';
import { PaymentOperations } from '../../utils/PaymentOperations';
import { ClearPhone } from '../../utils/ClearPhone';
import { printData } from '../../utils/PrintData';
import { normalizeApiError, showApiError } from '../../utils/ApiError';
import { hasPendingKitchenItems, hasPreOrderCode, shouldUsePreOrderPaymentPrintMode } from '../../utils/PreOrderPaymentPrint';
import {
  buildKinposFullAmount,
  findKinposPaymentMethodById,
  getKnownKinposCardNetworkPaymentMethodId,
  getKinposPendingOperationLabel,
  getPaymentIntegrationId,
  getPaymentMethodId,
  isKinposPaymentMethod,
  isKinposRegistrationRecoveryDraft,
  kinposPaymentBridge,
  resolveActualKinposPaymentMethod,
  toKinposPaymentRecord,
} from '../../utils/KinposBridge';
import Empty from '../utils/Empty';


import PaySheet from "./PaySheet/PaySheet";
import PayScroller from "./PaySheet/PayScroller";

import './css/modalPayMet.css'
// Normalize waiter shape to the one we use in POS flow
// Expected: { user_id, user_name, user_code }
const normalizeWaiter = (waiterLike) => {
  if (!waiterLike) return null
  const user_id = waiterLike.user_id ?? waiterLike.id ?? waiterLike.waiter_id ?? null
  const user_name = waiterLike.user_name ?? waiterLike.name ?? waiterLike.waiter_name ?? null
  const user_code = waiterLike.user_code ?? waiterLike.code ?? waiterLike.waiter_code ?? null
  if (!user_id) return null
  return { user_id, user_name, user_code }
}



const ModalPayMet = ({
  selectPreOrder,
  baseReducedTax,
  selectedDeliveryRule,
  invoiceTaxDeliveryFee,
  preOrderInvoice, dv, name, ruc, setDv, setName,
  setRuc, dataResponse, optionalData, setDataResponse,
  setOptionalData, shoppingCart, shoppingCartCombos,
  total, subtotal, discount, tax, setPageLoader, delivery,
  dataPreOrder, checkDeliveryOrder, registerTurnOrder,
  setRegisterTurnOrder, client_phone, setClient_phone,
  locator, setLocator, dataClient, setDataClient,
  listPaymentReady, setlistPaymentReady, amountPaymentReady,
  setAmountPaymenReady, tableInfo, taxesArrayAll, dataDicountApply,
  invoiceTips, setInvoiceTips, moduleTips, recomendationTips, totaltopay,
  setEventHandler, pos_integration_name, dataReferenceOrderMicros, parthner_order, parthners,
  codeParthner, yappy_transaction_id, setYappy_transaction_id, showModuleLocator,
  cardGroup, paramsMicros, dataClientSelected, setdataClientSelected,
  addressNowLocation, setAddressNowLocation, businessLogo, domain, enabledOnlineOrder,
  setShoppingCart, calculateInvoiceTotals, recoveryOrderApproved, setRecoveryOrderApproved,
  selectRestaurant, setResetData, setShoppingCartCombos, orderNumber, setOrderNumber, orderNumberNow, setOrderNumberNow,
  dataStyleBusiness, sendMail, sendStatus, aditional_data, setAditional_data, addresDescriptionClientFiscal, setAddresDescriptionClientFiscal,
  eventDataState, events, eventSelect, hasPendingPreOrderCartChanges, isPointsPayment = false, pointsTotal = 0,
  // "Pagar con POS": when set, this charge came from a pre-pago table's "Pagar con POS" request
  // (see PaymentPost.jsx's location.state?.posPaymentRequest) - {session_uuid, payment_attempt_id,
  // calculation_id}. formatDataOrder below short-circuits on this instead of registering a brand
  // new classic Order, since the goal is marking only the requested lines PAID without closing the
  // table's account (services/tableSessionPayments.js#confirmPaymentClaim on the backend).
  posPaymentContext = null,
  onPosPaymentSettled,
  // Solo PaymentPost embebido en /reservation: avisa que el cajero cerro el Centro de Pagos por su
  // cuenta (overlay, Escape o "Cancelar") sin cobrar, para que Reservation desmonte la pantalla.
  onDismiss
}) => {

  //States
  const [paymentMethod, setPaymentMethod] = useState([])
  const [show, setShow] = useState(false);
  const [showModalProcess, setShowModalProcess] = useState(false);
  const [showModalPhone, setShowModalPhone] = useState(false);
  const [showModalPageYappy, setShowModalPageYappy] = useState(false);
  const [printers, setPrinters] = useState([]);
  const [microsModule, setMicrosModule] = useState(0)
  const [dataPrint, setDataPrint] = useState({})
  const [txtErrorRegisterOrder, setTxtErrorRegisterOrder] = useState("")


  const [showEditBill, setShowEditBill] = useState(false);
  const handleEditBillClose = () => setShowEditBill(false);
  const handleEditBillShow = () => setShowEditBill(true);


  //cashier states
  const [emailInput, setEmailInput] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [modalShowErrorRegisterOrder, setModalShowErrorRegisterOrder] = useState(false)
  const [detailOrder, setDetailOrder] = useState();
  const [amountOrder, setAmountOrder] = useState();
  const [showModalInsufficientFunds, setShowModalInsufficientFunds] = useState(false);
  const [insufficientMessage, setInsufficientMessage] = useState("");
  const [paymentInfo, setPaymentInfo] = useState({ payment: "" })
  const [showModalMixto, setShowModalMixto] = useState(false)
  const [showPaymentManual, setPaymentManual] = useState(false)
  const [datatransaction_code, setDataTransaction_code] = useState("");
  const [order_id, setOrder_id] = useState("");
  const [order_code, setOrderCode] = useState("");
  const [client_type, setClient_type] = useState(0);
  const [dgiUrl, setDgiUrl] = useState("");
  const [cufe, setCufe] = useState("");
  //const [orderNumber, setOrderNumber] = useState("0")
  //const [orderNumberNow, setOrderNumberNow] = useState("0")
  const [orderNumbeTemp, setOrderNumberTemp] = useState({ code: "", temp_id: "" })
  const [responseQr, setResponseQr] = useState(false)
  const [paymentApproval, setPaymentApproval] = useState({ status: 0, description: "Procesando pago" })
  const [windows_ip, setWindows_ip] = useState("");
  const [infoPrinter, setInfoPrinter] = useState({ printer_comanda: "", printer_ticket: "", printer_ip: "" })
  const [EMVStreamResponse, setEMVStreamResponse] = useState({ EMVStreamResponse: "" })
  const [change, setChange] = useState(0);
  const [tempMethodPayment, setTempMethodPayment] = useState(0)
  const [amountPending, setAmountPending] = useState(0)
  const [lastOrder_id, setLastOrder_id] = useState("");
  const [orderToRecovery, setOrderToRecovery] = useState(null);
  const [showModalWaiters, setShowModalWaiters] = useState(false);
  const [selectedWaiter, setSelectedWaiter] = useState(null);
  const [pendingOpenPayment, setPendingOpenPayment] = useState(false);
  const [pointsRedeemLoading, setPointsRedeemLoading] = useState(false);
  const [kinposPaymentPending, setKinposPaymentPending] = useState(() => {
    const pendingPayment = kinposPaymentBridge.getPendingPayment();
    return pendingPayment?.mode === "full";
  });
  const kinposResultHandlerRef = useRef(null);
  //Cashback states
  const [cashback, setCashback] = useState(0);
  const [cashbackModal, setCashbackModal] = useState(false);

  //Yappy QR
  const [statePayment, setStatePayment] = useState(false);
  const [modalYappyQr, setModalYappyQr] = useState(false);
  const [dataYappy, setDataYappy] = useState({});
  const [dataHash, setDataHash] = useState("");
  const [statusRequestYappy, setStatusRequestYappy] = useState(false);

  const [contAuthRuc, setCountAucthRuc] = useState(0)

  let ventanaYappy = 0;

  // "Pagar con POS": nothing else opens this modal for a table-claim charge (PaymentPost.jsx just
  // prefills the cart and sets this context) - open it as soon as the context/cart arrive. Tracks
  // whether THIS modal instance is currently open because of a pos-payment context (not any other
  // reason a cashier might have the modal open) so that when PaymentPost.jsx clears the context
  // (claim confirmed/released/expired - see its tableSessionOrderUpdated handler), the modal closes
  // itself instead of sitting open on a stale/invalid request.
  const posPaymentActiveRef = useRef(false);
  useEffect(() => {
    if (posPaymentContext?.payment_attempt_id) {
      posPaymentActiveRef.current = true;
      setShow(true);
    } else if (posPaymentActiveRef.current) {
      posPaymentActiveRef.current = false;
      setShow(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [posPaymentContext?.payment_attempt_id]);

  // Devuelve la fecha y hora actual en formato 'YYYY-MM-DD HH:mm:ss'
  function getCurrentDateTime() {
    const now = new Date();
    const pad = (n) => n.toString().padStart(2, '0');
    const year = now.getFullYear();
    const month = pad(now.getMonth() + 1);
    const day = pad(now.getDate());
    const hours = pad(now.getHours());
    const minutes = pad(now.getMinutes());
    const seconds = pad(now.getSeconds());
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  //avi-ina
  const [botonDeshabilitado, setBotonDeshabilitado] = useState(false);

  let machine = localStorage.getItem('machine');
  let business = localStorage.getItem('business');

  //We validate if the machine is logged in
  if (business !== null && business !== undefined && business !== '') {
    business = JSON.parse(localStorage.getItem('business'))
  }

  //We validate if the machine is logged in
  if (machine !== null && machine !== undefined && machine !== '') {
    machine = JSON.parse(localStorage.getItem('machine'))
  }


  let instervalCash = 0

  //Functions to show and hide the modal cashier
  const handleCloseModal = () => setModalShow(false);
  const handleShowModal = () => setModalShow(true)

  //get client by business 
  const getClientsByBusiness = async () => {
    let token = localStorage.getItem('x-access-machine-token');
    return new Promise(async (resolve, reject) => {
      try {

        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let business_id = business.id
        if (parthner_order == true) {
          business_id = branchoffice.parthner_business
        }
        const response = await ClientsFetchAPI.getClientsByBusiness(business_id, token);
        resolve(response.data.data);
      } catch (err) {

        reject(err);
      }
    });
  }

  //create client in the business
  const createClient = async (name, dv, typeRuc, client_type) => {
    let token = localStorage.getItem('x-access-machine-token');
    let data = {
      "phone": "6000-0000",
      "name": name,
      "billing_name": name,
      "business_code": business.code,
      "client_type_id": client_type,
      "gender": "Masculino",
      "client_ruc_type": typeRuc,
      "ruc": ruc,
      "dv": dv,
      "location": "0",
      "is_validated": 1,
      "password": "123456789",
      "passwordCheck": "123456789",
    }


    let DataGeneral = JSON.parse(localStorage.getItem('generalData'))
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    if (parthner_order == true) {
      DataGeneral.forEach((business) => {

        if (business.data.business.id == branchoffice.parthner_business) {
          data.business_code = business.data.business.code
        }
      })
    }
    try {
      const response = await ClientsFetchAPI.createClient(data, token)
    } catch (err) {

    }
  }


  //Validate that the client already exists, if it does not exist, send it to validate with the dgi
  const validDataClient = async () => {
    let getClients = {}

    try {
      getClients = await getClientsByBusiness();
    } catch (err) {
      getClients = [{ ruc: "0" }]
    }
    let ruc_client = ruc
    const result = getClients.find(({ ruc }) => ruc === ruc_client);


    if (result === undefined) {
      authenticationDgi()
    } else {
      if (result.billing_name !== null && result.billing_name !== "" && result.billing_name !== undefined) {
        setName(result.billing_name)
        setDv(result.dv)
        setDataResponse(true)
      } else {
        authenticationDgi(result)
      }
    }
  }

  const getClientType = async (dTipoRec) => {
    let token = localStorage.getItem('x-access-machine-token');
    try {
      const responseTypeClient = await ClientsFetchAPI.getClientType(token)

      let dataTypes = responseTypeClient.data.data;

      let dataNow = dataTypes.find(type => type.name.toLowerCase() == dTipoRec.toLowerCase())
      if (dataNow != undefined) { return dataNow.id } else { return 2 }
    } catch (err) {

      return 2;
    }
  }

  //function to authentication of ruc
  const authenticationDgi = async (dataclientUpdate) => {
    let message = ""
    let title = ""
    let icon = ""
    if (ruc == "") {
      message = "No se ha ingresado ningun ruc."
      title = "Debes ingresar un ruc."
      icon = "warning"
      ErrorAlert(message, title, icon)
    } else {
      LoadingAlert()
      let token = localStorage.getItem('x-access-machine-token');
      let data = { ruc: ruc }
      try {
        const response = await AuthDgiFetchAPI.authenticationRuc(token, data)
        let dataDgi = response.data
        let dTipoRec = dataDgi?.dgi_response?.dTipoRec ? dataDgi.dgi_response.dTipoRec : "Consumidor final"
        let clientType = await getClientType(dTipoRec)
        setClient_type(clientType)

        if (dataDgi.dgi_response.gResProc) {
          if (dataDgi.dgi_response.gResProc.dCodRes == "0680") {
            let dvDgi = dataDgi.dgi_response.dDV
            if (dvDgi.length < 2) { dvDgi = "0" + dvDgi }
            setName(dataDgi.dgi_response.dNomb)
            setDv(dvDgi)
            message = "Datos del clientes obtenidos por la DGI"
            title = "Datos obtenido correctamente"
            icon = "success"
            ErrorAlert(message, title, icon)
            setDataResponse(true);

            //We proceed to create or update the client
            if (dataclientUpdate !== undefined) {
              updateClient(dataDgi.dgi_response.dNomb, dvDgi, dataDgi.dgi_response.dTipoRuc, clientType, dataclientUpdate)
            } else {
              createClient(dataDgi.dgi_response.dNomb, dvDgi, dataDgi.dgi_response.dTipoRuc, clientType)
            }

            setCountAucthRuc(0)
          } else {

            if (contAuthRuc < 1) {
              message = "Intente nuevamente."
              title = "Datos no encontrados"
              icon = "warning"
              ErrorAlert(message, title, icon)
              setCountAucthRuc((contAuthRuc + 1))
            } else {
              setOptionalData(true)
              message = "Ingrese los datos manualmente."
              title = "Datos no encontrados"
              icon = "warning"
              ErrorAlert(message, title, icon)
              setCountAucthRuc(0)
            }

            message = "Ingrese los datos manualmente."
            title = "Datos no encontrados"
            icon = "warning"
            ErrorAlert(message, title, icon)

          }
        }
      } catch (err) {

        setOptionalData(true)
        message = "Ingrese los datos manualmente."
        title = "Datos no encontrados"
        icon = "warning"
        ErrorAlert(message, title, icon)
        setCountAucthRuc(0)
      }
    }
  }

  //function to update client info
  const updateClient = async (billing_name, dv, typeRuc, clientType, dataclientUpdate) => {
    let token = localStorage.getItem('x-access-machine-token')
    let business = JSON.parse(localStorage.getItem('business'))
    let data = { billing_name: billing_name, dv: dv, client_type_id: clientType, business_code: business.code, client_ruc_type: typeRuc, };
    try {
      const response = await ClientsFetchAPI.updateClient(data, dataclientUpdate.id, token)

    } catch (err) {

    }

  }

  // get order number in process
  /*const getOrderNumber = async (branchoffice_id, token) => {
    try {
      const response = await OrderNumberFetchAPI.getOrderNumber(branchoffice_id, token)

      setOrderNumber(response.data.next_transaxtion_code);
      setOrderNumberNow(response.data.next_transaxtion_code);

      //setOrderNumber((parseInt(response.data.last_transaction_code) + 1));
      //setOrderNumberNow((parseInt(response.data.last_transaction_code) + 1));
    } catch (err) {

    }
  }*/

  //function get payment method by machine
  const getPaymentMethod = async (machine_id, token) => {
    try {
      const response = await PaymentMethodFetchAPI.getPaymentMethod(machine_id, token);
      setPaymentMethod(Array.isArray(response.data.data) ? response.data.data : []);
    } catch (error) {

    }
  }

  //save info of payment
  const selectPayment = (e) => {
    let token = localStorage.getItem('x-access-machine-token');
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))


    //getOrderNumber(branchoffice.id, token)
    if (e.target.checked == true) {
      let payment = JSON.parse(e.target.value)
      setPaymentInfo(payment)
    }
  }

  const showKinposFailure = (failure = {}) => {
    const isUncertain = failure.status === "uncertain";
    const title = isUncertain
      ? "Resultado pendiente de confirmacion"
      : failure.status === "declined"
        ? "Pago rechazado"
        : failure.status === "cancelled"
          ? "Pago cancelado"
          : "No se pudo procesar el pago";
    const defaultMessage = isUncertain
      ? "El resultado del pago aun no ha sido confirmado. Estamos verificando la transaccion antes de permitir otro intento."
      : failure.status === "declined"
        ? "KinPOS rechazo el pago. Puedes intentar nuevamente."
        : failure.status === "cancelled"
          ? "El cobro fue cancelado y la orden no fue registrada."
          : "No se pudo completar el cobro KinPOS/PAX.";
    const technicalDetail = [
      failure.request_id ? `Solicitud: ${failure.request_id}` : "",
      failure.code ? `Codigo: ${failure.code}` : "",
    ].filter(Boolean).join(" | ");

    ErrorAlert(
      failure.message || defaultMessage,
      title,
      failure.status === "cancelled" ? "info" : "warning",
      undefined,
      { detail: technicalDetail }
    );
  }

  function completeKinposAfterOrderRegistration(order) {
    const pendingPayment = kinposPaymentBridge.getPendingPayment();
    const canAcknowledge = pendingPayment
      && ["processing_result", "registration_failed", "awaiting_registration"].includes(pendingPayment.state)
      && String(pendingPayment.order_reference) === String(order?.transaction_code);
    if (canAcknowledge) {
      kinposPaymentBridge.complete(pendingPayment.request_id);
    }
  }

  const requestKinposPayment = async (selectedPayment) => {
    if (kinposPaymentPending || kinposPaymentBridge.hasPendingPayment()) {
      showKinposFailure({ status: "uncertain" });
      return;
    }

    if (!kinposPaymentBridge.isAvailable()) {
      setBotonDeshabilitado(false);
      ErrorAlert(
        "La integracion KinPOS/PAX no esta disponible en este dispositivo.",
        "Terminal no disponible",
        "warning"
      );
      return;
    }

    const orderReference = dataPreOrder?.pre_Order === true
      ? dataPreOrder.transaction_code || dataPreOrder.code || orderNumber
      : orderNumber;

    setKinposPaymentPending(true);
    setTempMethodPayment(0);
    setPaymentApproval({ status: 0, description: "Procesando pago en el terminal KinPOS/PAX..." });
    setShowModalProcess(true);

    try {
      await kinposPaymentBridge.charge({
        payment: selectedPayment,
        amount: buildKinposFullAmount({
          total: totaltopay,
          taxes: taxesArrayAll,
          tip: invoiceTips,
        }),
        orderReference,
        mode: "full",
      });
    } catch (error) {
      setPaymentApproval({ status: 2, description: error.message || "Error de comunicacion con KinPOS" });
      setShowModalProcess(false);
      showKinposFailure(error);
      setKinposPaymentPending(false);
      setBotonDeshabilitado(false);
    }
  }

  const getClientAvailablePoints = (client) => {
    const points = parseFloat(client?.points);
    return Number.isFinite(points) ? points : 0;
  }

  const hasEnoughPointsForOrder = (client = dataClientSelected) => {
    return getClientAvailablePoints(client) >= Number(pointsTotal || 0);
  }

  const getPointsPaymentInfo = () => {
    const creditPayment = paymentMethod.find((method) => method.payment === "Credito") || {};
    const integration = creditPayment.integration || { id: 3, name: "Manual" };

    return {
      ...creditPayment,
      payment: "Credito",
      payment_id: creditPayment.payment_id || creditPayment.id || 10,
      id: creditPayment.id || creditPayment.payment_id || 10,
      integration,
      points_payment: true,
      points_total: pointsTotal,
      points_payment_note: `Pago con puntos: ${pointsTotal} pts`
    }
  }

  const getZeroPointsTax = () => ({
    tax_id: 4,
    tax: "0%",
    taxtValue: 0,
    dTasaITBMSValue: "00",
    percentage: "0%",
    total: 0
  })

  const formatPointsOrderItem = (item) => {
    if (!item) return item;

    const zeroMoneyFields = {
      price: 0,
      base_price: 0,
      valueOriginal: 0,
      unit_discount: 0,
      product_discount: 0,
      descuento: 0,
      discount: 0,
      suggested_price: 0,
      total: 0,
      subtotal: 0,
      total_product: 0
    };

    return {
      ...item,
      ...zeroMoneyFields,
      taxes: [getZeroPointsTax()],
      paid_with_points: true,
      points_total: item.points_total || item.points_value || 0,
      segments: Array.isArray(item.segments)
        ? item.segments.map((segment) => ({ ...segment, ...zeroMoneyFields, taxes: [getZeroPointsTax()] }))
        : item.segments,
      DetalleSegmentos: Array.isArray(item.DetalleSegmentos)
        ? item.DetalleSegmentos.map((segment) => ({ ...segment, ...zeroMoneyFields, taxes: [getZeroPointsTax()] }))
        : item.DetalleSegmentos,
      groups: Array.isArray(item.groups)
        ? item.groups.map((group) => formatPointsOrderItem(group))
        : item.groups
    };
  }

  const redeemFrequentShopperPoints = async ({ clientId, points, orderId }) => {
    const token = localStorage.getItem('x-access-machine-token');
    return ClientsFetchAPI.manageFrequentShopperPoints(clientId, {
      points,
      action: "remove",
      order_id: orderId,
      description: `Canje POS orden ${orderNumber}`
    }, token);
  }

  const processPointsPayment = async () => {
    if (!dataClientSelected?.id) {
      ErrorAlert("Debes seleccionar o crear un cliente para validar sus puntos.", "Cliente requerido", "warning");
      return;
    }

    if (!hasEnoughPointsForOrder(dataClientSelected)) {
      ErrorAlert("El cliente no tiene suficientes puntos para esta venta.", "Puntos insuficientes", "warning");
      return;
    }

    setPointsRedeemLoading(true);
    const pointsPaymentInfo = getPointsPaymentInfo();
    setPaymentInfo(pointsPaymentInfo);

    formatDataOrder(0, true, pointsPaymentInfo, dataClientSelected, {
      points_payment: {
        client_id: dataClientSelected.id,
        points: pointsTotal
      }
    });
  }

  //function process payment of the order
  const processPayment = async () => {
    // "Pagar con POS": last-resort synchronous guard against starting a physical charge (KinPOS or
    // otherwise) for a claim that already expired server-side - covers the race where the cashier
    // clicks "Pagar" in the instant before the expiry socket event (tableSessionOrderUpdated,
    // handled in PaymentPost.jsx) arrives and closes this modal. expires_at comes from the backend
    // (see tableSessionPayments.js#getClaimTtlMsForChannel) - never guessed/hardcoded here.
    if (posPaymentContext?.expires_at && new Date(posPaymentContext.expires_at).getTime() < Date.now()) {
      ErrorAlert(
        "La solicitud de pago del cliente vencio antes de confirmarse. No cobres en el datafono por este intento.",
        "Solicitud de cobro vencida",
        "warning"
      );
      setShow(false);
      onPosPaymentSettled?.({ success: false, expired: true });
      return;
    }

    let title = 'Cargando....'
    let message = 'Cargando información....<br/> <br/>'
    let namePayment = paymentInfo.payment
    //-----------------------------------------------------
    setBotonDeshabilitado(true);
    if (namePayment != "") {
      if ((shoppingCart.length + shoppingCartCombos.length) > 0) {
        if (isKinposPaymentMethod(paymentInfo)) {
          await requestKinposPayment(paymentInfo);
          return;
        }

        if (namePayment == 'Efectivo' || namePayment == 'PCCCOIN') {
          title = 'Esperando aprobacion....'
          message = 'El administrador esta aprobando el pago....<br/> <br/>'
          //LoadingAlert(title, message)
          //createOrderCash("Efectivo")

          if (paymentInfo.integration.id == 8) {
            setCashValidator()
          } else {
            setDetailOrder({ total: totaltopay, code: "0000" })
            handleShowModal()
          }


        } else if (namePayment == 'Credito' || namePayment == 'Transf./Deposito a cta. Bancaria') {
          title = 'Generando orden....'
          message = 'Espere por favor....<br/> <br/>'
          LoadingAlert(title, message)
          formatDataOrder(0, true)
        } else if (namePayment == 'Yappy') {
          setShowModalPhone(true)
          setChange(0);
        } else if (namePayment == 'Yappy QR') {
          setShowModalProcess(true);
          GenerateYappyTransaction()
        } else if (namePayment == "Mixto") {
          setAmountPending((parseFloat(totaltopay).toFixed(2) - parseFloat(amountPaymentReady).toFixed(2)))
          setShowModalMixto(true)

        } else {
          if (paymentInfo.integration.id == 1) {

            requestPyament();
          } else if (paymentInfo.integration.id == 3) {

            setPaymentManual(true)
          } else if (paymentInfo.integration.id == 6) {

            //We check if the payment is cash 
            if (namePayment == 'Cash') {
              //We continue the cash process payment 
              setDetailOrder({ total: totaltopay, code: "0000" })
              handleShowModal()
            } else {
              let cashback = paymentInfo.params.find((element) => element.name === "iscashback");
              //We check if the cashbak is enabled
              if (cashback !== undefined && cashback.value === "yes") {
                setCashbackModal(true);
              } else {
                requestPaymentEvertech(paymentInfo);
              }
            }
          } else if (paymentInfo.integration.id == 4) {

            requestPaymentBanesco(paymentInfo);
          }

          setChange(0);
        }

        setTimeout(() => {
          setTempMethodPayment(1);
        }, 15000);
      } else {
        ErrorAlert("No hay productos en el carrito", "Agrega un producto", "info");
      }

    } else {
      ErrorAlert("No hay metodo de pago.", "Selecciona un metodo de pago", "info");
      setBotonDeshabilitado(false)
    }
  }

  //decimal reduction
  const decimalReduction = (value) => {

    let string = value.toString()
    let arrayString = string.split(".");
    let newDecimalString = []
    let sample = ''
    if (arrayString[1] != undefined) {
      newDecimalString = arrayString[1].slice(0, 2);
      sample = arrayString[0] + "." + newDecimalString

    } else {
      sample = string;
    }

    let endValue = parseFloat(sample)
    return endValue
  }

  //genrate yappy transaction
  const GenerateYappyTransaction = async () => {
    if (statePayment == false) {
      setStatePayment(true)
      LoadingAlert()
      let token = localStorage.getItem('x-access-machine-token');
      let machine = JSON.parse(localStorage.getItem('machine'));
      let data = {
        "machine_id": machine.id,
        "total": decimalReduction(totaltopay).toString(),
        "subtotal": decimalReduction(totaltopay).toString(),
        "tax": "0",
        "discount": "0",
        "transaction_code": orderNumber,
        "description": "Smartpay - orden:" + orderNumber,
        "params": paymentInfo.params
      }
      try {
        const response = await YappyFetchAPI.newYappyQr(data, token)
        setStatePayment(false)
        ErrorAlert("", "Todo listo para que realices el pago", "info")
        setDataYappy(response.data);
        setYappy_transaction_id(response.data.yappy_transaction.body.transactionId)
        setDataHash(response.data.yappy_transaction.body.hash)
        setModalYappyQr(true)
        setStatusRequestYappy(true)
        //getYappyTransaction(response.data)

      } catch (err) {
        setStatePayment(false)
        showApiError(err, {
          title: "Yappy no esta disponible",
          message: "No se pudo generar la transaccion Yappy.",
          context: `order=${orderNumber}`,
          icon: "warning",
        }, ErrorAlert)

      }
    } else {

    }
  }

  const hadleCancelYappy = (text) => {

    if (text != undefined) {
      setPaymentApproval({ status: 2, description: text });
    } else {
      setPaymentApproval({ status: 2, description: "CANCELADO" });
    }

    setYappy_transaction_id("")
    setModalYappyQr(false);
    setStatusRequestYappy(false)

    setTimeout(() => {
      setShowModalProcess(false);
      setPaymentInfo({ payment: "", payment_id: 0 })

      setPaymentApproval({ status: 0, description: "Procesando pago..." })
    }, 3000);
  }

  // Function to get yappy transaction status
  const getYappyTransaction = async () => {
    let token = localStorage.getItem('x-access-machine-token');

    try {
      let yappy_transaction_id = dataYappy.yappy_transaction.body.transactionId

      const response = await YappyFetchAPI.getYappyTransaction(yappy_transaction_id, token);

      let status = response.data.yappy_transaction.body.status;

      switch (status) {
        case 'PENDING':

          break;

        case 'COMPLETED':


          setModalYappyQr(false)
          setStatusRequestYappy(false)
          setPaymentApproval({ status: 1, description: "APROBADO" })
          setShow(false)
          setTimeout(() => {

            formatDataOrder(yappy_transaction_id, true)
            setShowModalProcess(false);
            setPaymentApproval({ status: 0, description: "Procesando pago..." })
          }, 3000);

          break;

        case 'DECLINED':
          setPaymentInfo({ payment: "" })
          setDataHash("")
          setYappy_transaction_id("")
          hadleCancelYappy('DECLINED')

          break;

        case 'EXPIRED':
          setPaymentInfo({ payment: "" })
          setDataHash("");
          setYappy_transaction_id("")
          hadleCancelYappy('EXPIRED')
          break;

        case 'FAILED':
          setPaymentInfo({ payment: "" })
          setDataHash("")
          setYappy_transaction_id("")
          hadleCancelYappy('FAILED')
          break;

        case 'VOIDED':
          setPaymentInfo({ payment: "" })
          setDataHash("")
          setYappy_transaction_id("")
          hadleCancelYappy('VOIDED')
          break;

      }

    } catch (err) {

      setPaymentInfo({ payment: "" })
      setDataHash("")
      setYappy_transaction_id("")
      hadleCancelYappy("ERROR DE CONSULTA")
    }

  }

  //next step phone number yappy
  const nextStepYappy = (btnYappy, phoneClientYappy, event) => {
    //We check if the event is create and make the request for the yappy btn order
    if (event === "create") {
      //request Yappy btn order
      requestYappyBtnOrder(btnYappy, phoneClientYappy)
    } else
      //We make the denied work flow
      if (event === "DENIED") {
        setShowModalProcess(true);
        setShowModalPhone(false);
        setPaymentApproval({ status: 2, description: "Pago rechazado por el usuario" })
        setTimeout(() => {
          setShowModalProcess(false);
          //We reset the page 
          window.location.reload();
        }, 3000);
      } else
        //We make the expired work flow
        if (event === "EXPIRED") {
          setShowModalProcess(true);
          setShowModalPhone(false);
          setPaymentApproval({ status: 2, description: "Pago expirado" })
          setTimeout(() => {
            setShowModalProcess(false);
            //We reset the page
            window.location.reload();
          }, 3000);
        } else {
          let generalData = localStorage.getItem("generalData");
          let paymentInfo = {}
          AlertSmall("Pago realizado con exito", "success")

          //We check if the general data is a string and parse it to an object
          if (generalData && generalData !== null && generalData !== undefined) {
            generalData = JSON.parse(generalData);
            let params = generalData[0].data.paymentMethods.find(payment => payment.payment === "Yappy");
            //We check if the params of yappy btn are defined
            paymentInfo = params
          }
          setPaymentApproval({ status: 1, description: "Realizado" });
          setShowModalProcess(true);
          setShow(false);
          setShowModalPhone(false);
          setTimeout(() => {
            localStorage.removeItem("OrderDetails");
            setShowModalProcess(false);
          }, 3000);
        }

  }

  //Function to request a yappy btn order 
  const requestYappyBtnOrder = async (btnYappy, phoneClientYappy) => {
    try {
      const response = await YappyFetchAPI.newYappyBtnOrder({
        "params": [],
        "total": totaltopay.toFixed(2),
        "subtotal": subtotal.toFixed(2),
        "taxes": tax.toFixed(2),
        "discount": discount.toFixed(2),
        "transaction_code": orderNumber,
        "description": "Smartpay - orden:" + orderNumber,
        "phone": phoneClientYappy,
        "machine_id": machine.id,
      }, localStorage.getItem('x-access-machine-token'));



      //We check the response of yappy 
      if (response.data.yappy_order && response.data.yappy_order.body.documentName && response.data.yappy_order.body.transactionId) {
        const params = {
          transactionId: response.data.yappy_order.body.transactionId,
          documentName: response.data.yappy_order.body.documentName,
          token: response.data.yappy_order.body.token
        }
        //We check the btn yappy
        if (btnYappy && typeof btnYappy.eventPayment === "function") {
          btnYappy.eventPayment(params);
        }

        //We create a temporal order of yappy
        createPreOrder(null, params)

        AlertSmall("Revisa tu yappy en pendientes", "info")
      }
    } catch (err) {

      setPaymentApproval({ status: 2, description: "Algo salio mal" });
      setShow(false);
      setTimeout(() => {
        setShowModalProcess(false);
      }, 3000);
    }
  }

  //create preOrder
  const createPreOrder = async (payment, yappyParams) => {
    if ((shoppingCart.length + shoppingCartCombos.length) > 0) {
      LoadingAlert()
      let token = localStorage.getItem('x-access-machine-token');
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      let machine = JSON.parse(localStorage.getItem('machine'))
      let user = JSON.parse(localStorage.getItem('user'));

      let json = {
        "client_name": "Cliente generico",
        "localizador": "00",
        "client_phone": "0",
        "ruc": "0000",
        "dv": "00",
        "client_id": 0,
        "dgi_qr": "0",
        "Orden": shoppingCart,
        "combos": shoppingCartCombos,
        "Descuento": discount,
        "Total": total,
        "itbms": tax,
        "taxes": taxesArrayAll,
        "subtotal": subtotal,
        "machine_id": machine.id,
        "branchoffice_id": branchoffice.id,
        "tipoOrden": "para llevar",
        "paymethod": 0,
        "is_discount_notification": false,
        "is_cupon": false,
        "is_devolution_notification": false,
        "is_pre_order": true,
        "user": {
          id: user.id,
          name: user.name,
          code: user.user_code
        },
        waiter: {
          "id": selectedWaiter?.id ?? 0,
          "name": selectedWaiter?.user_name ?? null,
          "code": selectedWaiter?.user_code ?? null,
        },
        "table_name": tableInfo.name,
        "table_code": tableInfo.table_code,
        "table_id": tableInfo.id,
        "table_password": tableInfo.password,

      }

      //We check if the params of yappy comes
      if (yappyParams !== undefined) {
        json.is_yappy_pay = true
        json.yappy_transaction_id = yappyParams.transactionId
        json.yappy_document_name = yappyParams.documentName
        json.yappy_order_token = yappyParams.token

        localStorage.setItem("yappy_transaction_id", yappyParams.transactionId);

        json.paymenthod_id = 6;
        json.paymenthod = "Yappy";
        json.paymenthod_integration_id = 2;
      }


      try {
        const response = await PreOrderFetchAPI.createPreOrder(json, token)
        let message = "Pago creado con exito."
        let title = "Operacion exitosa."
        let icon = "success"
        //AlertSmall(message, icon)
        //setShowModalConfirmation(false)
      } catch (err) {
        showApiError(err, {
          title: "No se pudo crear la precuenta",
          message: "El pago fue aprobado, pero no se pudo crear la precuenta asociada.",
          context: `order=${orderNumber} yappy=${yappyParams?.transactionId || "no"}`,
        }, ErrorAlert)
      }
    } else {
      ErrorAlert("Debes agregar  algo al carrito", "No hay productos en el carrito", "info")
    }
  }



  //function action print order
  const getPrinter = async () => {
    try {
      const response = await PrinterFetchAPI.getPrinter(localStorage.getItem('x-access-machine-token'), machine.id);

      let arrayPrinters = response.data.printers;
      let printer_Comanda = "";
      let printer_ticket = "";
      let printer_zebra = "";
      let printer_ip = "";
      for (let i = 0; i < arrayPrinters.length; i++) {
        if (arrayPrinters[i].printer_type == 'Tickets') {
          printer_ticket = arrayPrinters[i].printer_name
          printer_ip = arrayPrinters[i].ip || ""
        } else if (arrayPrinters[i].printer_type == 'Comanda') {
          printer_Comanda = arrayPrinters[i].printer_name
        } else if (arrayPrinters[i].printer_type == 'Zebra') {
          printer_zebra = arrayPrinters[i].printer_name;
        }
      }

      const printersWithCategories = await Promise.all(arrayPrinters.map(async (printer) => {
        try {
          const categoriesResponse = await CategriesPosFetchAPI.getCategoriesByPrinters(
            printer.printer_id,
            localStorage.getItem('x-access-machine-token')
          )
          return { ...printer, categories: categoriesResponse.data.categories }
        } catch (err) {
          return { ...printer, categories: [] }
        }
      }))

      setPrinters(printersWithCategories)
      setInfoPrinter({ printer_comanda: printer_Comanda, printer_ticket: printer_ticket, printer_zebra: printer_zebra, printer_ip: printer_ip });

    } catch (err) {

    }
  }


  //function of cash status
  const statusCash = (status) => {
    if (status == 1) {//aprobed

      //We check if the payment is cash evertech 
      if (paymentInfo.integration.id == 6) {
        //We send the request to the evertech payment
        requestPaymentEvertech(paymentInfo);
      } else {
        //We just call the function register order
        formatDataOrder(0, true)
      }
      handleCloseModal();
    } else if (status == 2) {//cancel
      handleCloseModal()
    }
  }

  //get order
  const getLastOrderMachineNow = async () => {
    let token = localStorage.getItem('x-access-machine-token');
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    let business = JSON.parse(localStorage.getItem('business'));

    try {
      const response = await FilterOrderFetchAPI.getLastOrderOfMachine(machine.id, token)
      let order_last_number = orderNumberNow.toString()

      if (order_last_number.length < 4) {
        order_last_number = "0" + order_last_number
      }

      if (order_last_number == response.data.last_order.transaction_code && total == response.data.last_order.total) {
        setModalShowErrorRegisterOrder(false)
        setDataTransaction_code(response.data.last_order.transaction_code)
        setShow(false)
        setResponseQr(true);
        let title = "ORDEN: " + response.data.last_order.transaction_code
        let text = "Total de la orden: $" + total.toFixed(2)

        if (dataPreOrder.pre_Order == true) { deleteTempPreOrder(response.data.last_order.transaction_code, response.data.last_order.order) }
        //ConfirmationAlert(title, text, setPageLoader)
        printOrder(response.data.last_order.order_id, response.data.last_order.transaction_code, undefined, {
          isPreOrderPayment: dataPreOrder.pre_Order === true,
        });
        setTempMethodPayment(0);
        setRegisterTurnOrder(1);

        //We show a success message when the order is approved when the type of payment is credit 
        if (paymentInfo.payment_id === 10) {
          SuccessAlert("Orden a credito generada", "Orden generada", "success")
        } else {
          SuccessAlert("Orden registrada con exito", "Orden generada", "success")
        }
        completeKinposAfterOrderRegistration({
          transaction_code: response.data.last_order.transaction_code,
        });
      } else {
        const pendingPayment = kinposPaymentBridge.getPendingPayment();
        const persistedOrder = JSON.parse(localStorage.getItem("OrderDetails"));
        if (
          pendingPayment
          && String(pendingPayment.order_reference) === String(persistedOrder?.transaction_code)
        ) {
          await registernewOrder(persistedOrder);
        } else {
          formatDataOrder(0, true)
        }
      }
    } catch (err) {
      setPointsRedeemLoading(false);
      const apiError = normalizeApiError(err, {
        title: "No se pudo consultar la ultima orden",
        message: "No se pudo validar si la orden fue registrada.",
        context: `machine=${machine?.id || ""} order=${orderNumberNow}`,
      });

      if (apiError.message === "No existe la ordern") {
        //registernewOrder(0)
      } else {
        ErrorAlert(apiError.message, apiError.title, apiError.icon, undefined, { detail: apiError.detail })
      }
    }
  }

  const setCashValidator = async () => {//set cash validator

    if (statePayment == false) {
      setStatePayment(true)
      setShowModalProcess(true);
      let data = { "Terminal": "Autoservicio 1", "Monto": totaltopay.toFixed(2), "recibido": "0.00", "cambio": "0.00" }
      try {
        const response = await RequestLocalFetchAPI.postCashMethod(data);
        setStatePayment(false)


        if (response.data.status == "APPROVED") {
          setPaymentApproval({ status: 1, description: "Aprobado" });
          setShow(false);
        } else {
          setPaymentApproval({ status: 2, description: "Error en el validador de efectivo" });

        }

        setTimeout(() => {
          if (response.data.status == "APPROVED") {
            formatDataOrder(0, true)
          } else {
            cancelMethodPayment()
          }

          setShowModalProcess(false);
          setPaymentApproval({ status: 0, description: "Procesando pago..." })
        }, 3000);

      } catch (err) {
        setPaymentApproval({ status: 2, description: "Error en el validador de efectivo" });

        setTimeout(() => {
          cancelMethodPayment()
          setShowModalProcess(false);
          setPaymentApproval({ status: 0, description: "Procesando pago..." })
        }, 3000);
      }
    }
  }

  //function action request pyment local
  const requestPyament = async (yappy_Temp_id) => {
    setShowModalProcess(true);
    let JsonTr = {}

    if (paymentInfo.payment != "Yappy") {
      /* JsonTr = [{
        Tipo: 'SALE',
        Producto: 'COBRAR',
        Itbms: tax.toFixed(2),
        Tips: invoiceTips,
        Descuento: discount.toFixed(2),
        Monto: totaltopay.toFixed(2),
        TipoVenta: paymentInfo.payment.toUpperCase(),
        paymentMethod: paymentInfo,
        orderid: yappy_Temp_id,
        tel: "507" + phoneClientYappy,
        total: totaltopay.toFixed(2),
        subtotal: subtotal.toFixed(2),
        taxes: tax.toFixed(2),
      }]; */

      let methodPayment = ""
      if (paymentInfo.payment == "MasterCard") {
        methodPayment = "MC"
      } else {
        methodPayment = paymentInfo.payment
      }

      JsonTr = [{
        Tipo: 'SALE',
        Producto: 'COBRAR',
        Itbms: tax,
        Descuento: discount.toFixed(2),
        Tips: invoiceTips,
        Monto: totaltopay,
        TipoVenta: methodPayment.toUpperCase(),
        paymentMethod: paymentInfo,
        orderid: orderNumber,
      }];
    }

    if (localStorage.getItem("token_session") !== null && localStorage.getItem("token_session") !== undefined && localStorage.getItem("token_session") !== "") {
      JsonTr[0].SmartpayId = localStorage.getItem("token_session")
    } else {
      let newToken = generateToken()
      JsonTr[0].SmartpayId = newToken
      localStorage.setItem("token_session", newToken)
    }

    try {

      const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, localStorage.getItem('x-access-machine-token'));
      setWindows_ip(response_machine.data.data.windows_ip);

      const response = await RequestLocalFetchAPI.postPaymentMethod(JsonTr, response_machine.data.data.windows_ip);


      setEMVStreamResponse(response.data.data.EMVStreamResponse)
      let responseCode = response.data.data.EMVStreamResponse.responseCode;
      let description = response.data.data.EMVStreamResponse.responseCodeDescription

      if (paymentInfo.payment != "Yappy") {
        if (responseCode == "00") {
          setPaymentApproval({ status: 1, description: description });
          setShow(false);
        } else {
          setPaymentApproval({ status: 2, description: description });
        }
      }

      setTimeout(() => {
        if (paymentInfo.payment != "Yappy") {
          if (responseCode == "00") {
            formatDataOrder(response.data.data.EMVStreamResponse, true)
          } else {
            localStorage.setItem("token_session", generateToken())
            printData(response.data.data, printers)
            cancelMethodPayment()
          }
        }
        setShowModalProcess(false);
        setPaymentApproval({ status: 0, description: "Procesando pago..." })
      }, 3000);

      setBotonDeshabilitado(false);
    } catch (err) {
      cancelMethodPayment()
      showApiError(err, {
        title: "No se pudo procesar el pago",
        message: "El metodo de pago no respondio correctamente.",
        context: `order=${orderNumber} payment=${paymentInfo.payment}`,
      }, ErrorAlert)

    }
  }

  //Function to request the payment with evertech
  const requestPaymentEvertech = async (paymentInfo) => {
    let response;
    //We get the user
    let user = JSON.parse(localStorage.getItem('user'));
    //We show the modal of the process
    setShowModalProcess(true);
    try {
      //We make the request to the evertech in base of the payment info
      if (paymentInfo.payment !== "Nota de credito" && paymentInfo.payment !== "Refund" && paymentInfo.payment !== "EBT Refund" && paymentInfo.payment !== "Cash Refund") {
        //We add to the paymentInfo some data that we need to make the payment
        paymentInfo.sECRStationID = machine.code;
        paymentInfo.sCashierID = user.id;
        paymentInfo.sRefNumber = orderNumberNow;
        paymentInfo.tips = invoiceTips;
        paymentInfo.total = total;
        paymentInfo.subtotal = subtotal;
        paymentInfo.tax = tax;
        paymentInfo.basereducedtax = baseReducedTax;
        paymentInfo.discount = discount;
        paymentInfo.taxes = taxesArrayAll;
        //We make the payment request
        response = await ProcessPayment(paymentInfo);
      } else {
        //We make the refund request
        response = await PaymentOperations({
          operationType: "refund",
          integrationType: 'Evertech',
          params: paymentInfo.params,
          taxes: taxesArrayAll,
          tax: tax,
          discount: discount,
          payment: paymentInfo.payment,
          tips: invoiceTips,
          total: total,
          basereducedtax: baseReducedTax,
          subtotal: subtotal,
          sECRStationID: machine.code,
          sCashierID: user.id,
          sRefNumber: orderNumberNow,
        });
      }

      //We check the response of evertech
      if (response && response.data !== undefined && response.data.response_message === "APPROVED") {
        setPaymentApproval({ status: 1, description: "APROBADO" });
        setShow(false);
        setTimeout(() => {
          formatDataOrder(response.data, true)
          setShowModalProcess(false);
          setPaymentApproval({ status: 0, description: "Procesando pago..." })
        }, 3000);
      } else if (response && response.data !== undefined && response.data.response_message === "PINPAD TIMEOUT") {
        setPaymentApproval({ status: 2, description: "Tiempo agotado" });
        setShowModalProcess(false);
      } else if (response && response.data !== undefined && response.data.response_message === "DUPLICATED TRANSACTION.") {
        setPaymentApproval({ status: 2, description: "Transaccion duplicada" });
        setShow(false);
        setTimeout(() => {
          setShowModalProcess(false);
          setPaymentApproval({ status: 0, description: "Procesando..." })
        }, 3000);
      } else if (response && response.data !== undefined && response.data.response_message === "DECLINED (Incorrect PIN)") {
        //console.log("PIN Incorrecto");
        setPaymentApproval({ status: 2, description: " PIN Incorrecto" });
        setShow(false);
        setTimeout(() => {
          setPaymentApproval({ status: 0, description: "Procesando..." })
          setShowModalProcess(false);
        }, 3000);
      } else if ((response && response.Informacion !== undefined) || (response && response.data && response.data.response_message === "Connection Error - LOGON")) {
        setPaymentApproval({ status: 2, description: "Pin pad no disponible" });
        setShow(false);
        setTimeout(() => {
          setShowModalProcess(false);
          setPaymentApproval({ status: 0, description: "Procesando..." })
        }, 3000);
      }
      else {
        setPaymentApproval({ status: 2, description: response.data.response_message !== undefined ? response.data.response_message : "Declinado, Error inesperado" });
        setShow(false);
        setTimeout(() => {
          setShowModalProcess(false);
          setPaymentApproval({ status: 0, description: "Procesando..." });

          //We check if the payment is EBT
          if ((paymentInfo.payment === "EBT" || paymentInfo.payment === "EBT Cash" || paymentInfo.payment === "EBT Unica" || paymentInfo.payment === "EBT Cash Unica" || paymentInfo.payment === "EBT Cash Advance")) {
            setInsufficientMessage(response.data.receipt_output.merchant + response.data.receipt_output.customer ? response.data.receipt_output.merchant + response.data.receipt_output.customer : null)
            setShowModalInsufficientFunds(true)
          }
        }, 6000);

      }
    } catch (err) {
      // Manejamos el error de manera segura
      console.error("Error durante el proceso de pago:", err);

      // Verificamos si el error tiene una respuesta o si viene formateado correctamente
      if (err.status && err.data) {
        setPaymentApproval({ status: 2, description: "Error: " + err.data });
      } else {
        setPaymentApproval({ status: 2, description: "Error inesperado: " + err.message });
      }

      // Ocultamos el modal de proceso después del error
      setShowModalProcess(false);
    }
  }


  //Function to request the payment with banesco
  const requestPaymentBanesco = async (paymentInfo) => {
    let response;
    //We get the user
    let user = JSON.parse(localStorage.getItem('user'));
    //We show the modal of the process
    setShowModalProcess(true);
    try {
      //We make the request to the evertech in base of the payment info
      if (paymentInfo.payment !== "Nota de credito" && paymentInfo.payment !== "Refund") {
        //We add to the paymentInfo some data that we need to make the payment
        paymentInfo.tips = invoiceTips;
        paymentInfo.total = total;
        paymentInfo.subtotal = subtotal;
        paymentInfo.tax = tax;
        paymentInfo.discount = discount;
        //We make the payment request
        response = await ProcessPayment(paymentInfo);
      } else {
        //We make the refund request
        response = await PaymentOperations({
          operationType: "refund",
          integrationType: 'Banesco',
          params: paymentInfo.params,
          tax: tax,
          discount: discount,
          payment: paymentInfo.payment,
          tips: invoiceTips,
          total: total,
          subtotal: subtotal
        });
      }

      //We check the response of banesco
      if (response && response.data !== undefined && response.data.TxnRspCode === "00") {
        setPaymentApproval({ status: 1, description: "APROBADO" });
        setShow(false);
        setTimeout(() => {
          formatDataOrder(response.data, true)
          setShowModalProcess(false);
          setPaymentApproval({ status: 0, description: "Procesando pago..." })
        }, 3000);
      } else {
        setPaymentApproval({ status: 2, description: response.data.TxnRspCode !== undefined ? `Declinado, error #${response.data.TxnRspCode}` : "Declinado, Error inesperado" });
        setShow(false);
        setTimeout(() => {
          setShowModalProcess(false);
          setPaymentApproval({ status: 0, description: "Procesando..." });
        }, 6000);
      }
    } catch (err) {
      // Manejamos el error de manera segura
      console.error("Error durante el proceso de pago:", err);

      // Verificamos si el error tiene una respuesta o si viene formateado correctamente
      if (err.status && err.data) {
        setPaymentApproval({ status: 2, description: "Error: " + err.data });
      } else {
        setPaymentApproval({ status: 2, description: "Error inesperado: " + err.message });
      }

      // Ocultamos el modal de proceso después del error
      setShowModalProcess(false);
    }
  }

  //create order cash temporal
  let type = 0
  const createOrderCash = async (type_method) => {
    let token = localStorage.getItem('x-access-machine-token');
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    let machine = JSON.parse(localStorage.getItem('machine'))
    type = 0
    let json = {
      "client_name": "Estimado cliente",
      "localizador": "",
      "client_phone": "",
      "dgi_qr": "",
      "Orden": shoppingCart,
      "Descuento": discount,
      "Total": total,
      "itbms": tax,
      "taxes": taxesArrayAll,
      "subtotal": subtotal,
      "machine_id": machine.id,
      "branchoffice_id": branchoffice.id,
      "tipoOrden": "comer aqui",
      "paymethod": paymentInfo.id,
      "is_discount_notification": false,
      "type_method": type_method,
      "transaction_code": orderNumber,


    }

    try {
      const response = await CashTempPosFetchAPI.createTempCash(json, token)

      if (type_method == "Yappy") {

        requestPyament(response.data.newTempOrder.code);
        setOrderNumberTemp({ code: response.data.newTempOrder.code, temp_id: response.data.newTempOrder._id })
      }

      console.log(response);
      getOrdersTempCash();
    } catch (err) {
      showApiError(err, {
        title: "No se pudo crear la orden temporal",
        message: "Se intentara recuperar una orden temporal existente.",
        context: `order=${orderNumber} payment=${type_method}`,
        icon: "warning",
      }, ErrorAlert)
      type = 1
      console.log("Hay una temporal");
      getOrdersTempCash();
      /*let erro_progress = err.response.data.error
      //!Error : Machine has an order in progress
      if (erro_progress === 'La maquina ya tiene una orden en progreso') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'La máquina ya tiene una orden en progreso',
        })
      }*/
      console.log(err);
    }
  }

  //get order temp cash
  let countGetCash = 0 // count to limit get orders
  const getOrdersTempCash = async () => {

    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    let machine = JSON.parse(localStorage.getItem('machine'))
    let business = JSON.parse(localStorage.getItem('business'))
    clearInterval(instervalCash)
    try {
      const response = await CashTempPosFetchAPI.getTempCash(machine.code, business.code, branchoffice.code)
      console.log(response);
      let code = response.data.order.code
      let message = ""
      let title = ""
      let icon = ""

      if (type == 0) {
        if (countGetCash == 0) {
          if (paymentInfo.payment != "Yappy") {
            handleShowModal();
          }
          setDetailOrder(response.data.order);
        }

        if (response.data.order.status_id == 1) {
          if (countGetCash <= 100) {
            instervalCash = setInterval(getOrdersTempCash, 5000)
            countGetCash++
          } else {
            message = "Tiempo de espera agotado"
            title = "Advertencia"
            icon = "warning"

            if (paymentInfo.payment == "Yappy") {
              ventanaYappy.close();
              setPaymentApproval({ status: 3, description: "Tiempo de espera agotado." });
            }
            handleCloseModal()
            updateOrderDiscount(code, 5, message, title, icon)
            countGetCash = 0
          }

          //!Fixed Eroor: Correjir mensjae y  poner loading 
        } else if (response.data.order.status_id == 8) {//order temporal is cancel

          title = "Operacion cancelada"
          message = "Orden temporal cancelada"
          icon = "error"

          setBotonDeshabilitado(false);

          if (paymentInfo.payment == "Yappy") {
            ventanaYappy.close();
            setPaymentApproval({ status: 3, description: "Ocurrio un error." });
          }
          updateOrderDiscount(code, 5, message, title, icon)


        } else if (response.data.order.status_id == 7) {//order temporal is confirm
          message = "El pago fue aprobado."
          title = "Pago exitoso"
          icon = "success"

          if (paymentInfo.payment == "Yappy") {
            ventanaYappy.close();
            setPaymentApproval({ status: 1, description: "Pago exitoso." });
          }

          if (paymentInfo.payment == "Efectivo") {
            setShow(false)
          }
          updateOrderDiscount(code, 3, message, title, icon)

          //function register order
          formatDataOrder(0, true)
        }
      } else if (type == 1) {
        console.log("Consulte la temporal remanante");
        updateOrderDiscount(code, 5, message, title, icon)
      }
    } catch (err) {
      console.log(err);
    }
  }

  //cancel temporal transaction yappy
  const cancelTempYappy = () => {
    let message = "Orden temporal cancelada"
    let title = "Operacion cancelada"
    let icon = "error"
    updateOrderDiscount(orderNumbeTemp.code, 5, message, title, icon)
  }

  //cancel method payment in process
  const cancelMethodPayment = () => {
    setTempMethodPayment(0);
    setPaymentApproval({ status: 0, description: "Procesando pago..." })

    //hidden screen modal 
    setStatePayment(false)
    setShowModalProcess(false);

    //if condition payments
    {/*if (paymentInfo.payment == "Yappy") {
      let message = "Orden temporal cancelada"
      let title = "Operacion cancelada"
      let icon = "error"
      updateOrderDiscount(orderNumbeTemp.code, 5, message, title, icon)
    } else {
      setShowModalProcess(false);
    }*/}
  }

  //function try again yappy
  const try_again_yappy = () => {
    setPaymentApproval({ status: 0, description: "Procesando pago..." })
    requestPyament(orderNumbeTemp.temp_id);
  }

  //update orders temporal discount
  const updateOrderDiscount = async (code, status, message, title, icon) => {
    console.log(code);
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    let business = JSON.parse(localStorage.getItem('business'))

    let jsonUpdate = {
      "order_code": code,
      "business_code": business.code,
      "branchoffice_code": branchoffice.code,
      "status": status
    }
    try {
      const response = await CashTempPosFetchAPI.updateOrderTempCash(jsonUpdate)
      console.log(paymentInfo.payment);

      if (type == 0) {
        if (paymentInfo.payment == "Yappy") {
          setTimeout(() => {
            setShowModalProcess(false);
            setPaymentApproval({ status: 0, description: "Procesando pago..." });
          }, 3000);
        }

        if (status == 5) {
          ErrorAlert(message, title, icon)
        }

      } else if (type == 1) {
        console.log("Solicite crear nuevamente la temporal");
        createOrderCash(paymentInfo.payment)
      }
    } catch (err) {
      console.log(err);
    }
  }

  //function to compare data micros and update
  const handlerComparativeNewData = (ip, RvcRef, employeeNum, host_url, micros_params, token, order_id) => {
    let preOrderComparativeOld = JSON.parse(localStorage.getItem('preOrderComparativeOld'))
    let OrderGroupsOld = preOrderComparativeOld.groups
    let OrderCombosOld = preOrderComparativeOld.combos
    let newGroups = []
    let newCombos = []
    //comparative groups
    shoppingCart.forEach(group => {
      let groupOld = OrderGroupsOld.find(item => item.group_id == group.group_id && item.segments_string == group.segments_string)

      if (groupOld != undefined) {
        if (groupOld.amount != group.amount) {
          let newGroup = groupOld
          newGroup.amount = (group.amount - groupOld.amount)
          newGroup.cantidadItem = (group.amount - groupOld.amount)
          newGroups.push(newGroup)

          console.log(newGroup);
        }
      } else {
        newGroups.push(group)
      }
    });

    //Add string data to compare
    shoppingCartCombos.forEach(combo => {
      let stringdata = combo.combo_id + "";
      combo.setGroups.forEach(setGroup => {
        stringdata += setGroup.set_id;
        setGroup.groups.forEach(group => {
          stringdata += group.group_id;
          group.segments.forEach(segment => {
            stringdata += segment.segment_id + segment.item.item_id;
          });
        });
      });
      combo.combo_string = stringdata;
    });

    //Add string data to compare
    OrderCombosOld.forEach(comboOld => {
      let stringdataOld = comboOld.combo_id + "";
      comboOld.setGroups.forEach(setGroup => {
        stringdataOld += setGroup.set_id;
        setGroup.groups.forEach(group => {
          stringdataOld += group.group_id;
          group.segments.forEach(segment => {
            stringdataOld += segment.segment_id + segment.item.item_id;
          });
        });
      });
      comboOld.combo_string = stringdataOld;
    });

    //==========================================
    //Comparative combos
    shoppingCartCombos.forEach(combo => {
      let comboOld = OrderCombosOld.find(comboOld => comboOld.combo_id == combo.combo_id && comboOld.combo_string == combo.combo_string)

      if (comboOld != undefined) {
        if (comboOld.amount != combo.amount) {
          let newCombo = comboOld
          newCombo.amount = (combo.amount - comboOld.amount)
          newCombo.cantidadItem = (combo.amount - comboOld.amount)
          newCombos.push(newCombo)
        }
      } else {
        newCombos.push(combo)
      }
    });

    let dataUpdateOrder = formatDataMicrosCheck(ip, RvcRef, employeeNum, host_url, newGroups, newCombos, "PUT")
    validTotalsMicros(ip, RvcRef, employeeNum, host_url, micros_params, token, order_id, "PUT", dataUpdateOrder)
  }

  //format data to send to micros
  const formatDataMicrosCheck = (ip, RvcRef, employeeNum, host_url, groups, combos, action) => {
    //Json general format
    let jsonMicrosCheck = {
      RvcRef: RvcRef,
      employeeNum: employeeNum,
      host_url: host_url,
      localMicrosServerIp: ip,
      products: [],
      automatic_payment: 1,
      delivery: false,
      client: { name: name, phone: "00" },
      paymentmethods: [{
        "name": paymentInfo.payment,
        "paymenthod_id": paymentInfo.payment_id,
        "total": total
      }],
    }

    if (action == "PUT") {
      let preOrderOld = JSON.parse(localStorage.getItem('preOrderComparativeOld'))
      jsonMicrosCheck.checkSeq = preOrderOld.micros_reference.checkSeq
      jsonMicrosCheck.checkNum = preOrderOld.micros_reference.checkNum
    }

    let data = []
    //json product format
    groups.forEach(product => {
      let dataDetail = {
        "code": product.group_id,
        "name": product.name,
        "price": product.price,
        "cant": product.amount,
        "tax": product.taxes[0].tax,
        "total_discount": product.discount,
        "exist_product": false,
        "total_product": product.price,
        "external_reference": product.external_reference,
        "type": "product",
      }

      let dataSegments = []
      product.segments.forEach(segment => {
        let detail = {
          "external_reference": segment.external_reference,
          "name": segment.name,
          "amount": segment.amount,
        }
        dataSegments.push(detail)
      })
      dataDetail.condiments = dataSegments
      data.push(dataDetail)
    });


    console.log(combos);
    //----------------------------------------------
    //format combos
    combos.forEach(combo => {
      console.log(combo);
      let dataDetailCombo = {
        "type": "combo",
        "code": combo.combo_id,
        "tax": combo.taxes[0].tax,
        "total_discount": combo.discount,
        "exist_product": false,
        "total_product": combo.price,
        "external_reference": combo.referenced_group.external_reference,
        "price": combo.price,
        "name": combo.name,
        "cant": combo.amount,
        "mainDetail": {},
        "sideDetails": [],
      }
      let setGroupsData = []
      combo.setGroups.forEach(setGroup => {
        setGroup.groups.forEach(group => {
          //json group format
          let dataDetail = {
            "name": group.name,
            "external_reference": group.external_reference,
            "isMainProduct": false,
          }

          let dataSegments = []
          group.segments.forEach(segment => {
            let detail = {
              "external_reference": segment.external_reference,
              "name": segment.name,
              "amount": segment.amount,
            }
            dataSegments.push(detail)
          })
          //add data segments to group
          dataDetail.condiments = dataSegments

          if (setGroup.isMainSetGroup == 1) {
            //add data to main detail
            dataDetail.isMainProduct = true
            dataDetailCombo.mainDetail = dataDetail
          } else {
            //add data to side details
            dataDetail.price = group.price
            dataDetail.cant = group.amount
            dataDetail.total = group.price
            setGroupsData.push(dataDetail)
          }
        })
        //add data side details to combo
        dataDetailCombo.sideDetails = setGroupsData
      })
      //add combo to products
      data.push(dataDetailCombo)
    })
    jsonMicrosCheck.products = data

    //return data format
    return (jsonMicrosCheck)
  }

  //validate totals micros
  const validTotalsMicros = async (ip, RvcRef, employeeNum, host_url, orderData, token, order_id, action, dataUpdateOrder) => {
    let order = formatDataMicrosCheck(ip, RvcRef, employeeNum, host_url, shoppingCart, shoppingCartCombos, action)
    try {
      let data = {
        Ruta: `http://${ip}:9472/api/micros/totals/checks?RvcRef=${RvcRef}&employeeNum=${employeeNum}&host_url=${host_url}`,
        Type: "POST",
        Header: { "x-access-token": token },
        Body: { products: order.products, tips: invoiceTips, localMicrosServerIp: ip }
      }

      console.log(data);

      const response = await RequestLocalFetchAPI.postMicros(data);
      let micros_response = response.data.micros_response.CalculateTransactionTotalsResponse.pTotalsResponse
      dataUpdateOrder.paymentmethods[0].total = micros_response.TotalsTotalDue._text
      //Create and update check in micros
      createCheckMicrosOrderLocal(ip, RvcRef, employeeNum, host_url, dataUpdateOrder, token, order_id, action)
    } catch (err) {
      console.log(err);
    }
  }

  // create transacction in micros
  const createCheckMicrosOrderLocal = async (ip, RvcRef, employeeNum, host_url, orderData, token, order_id, type) => {
    setMicrosModule(1)
    let data = {
      Ruta: `http://${ip}:9472/api/micros/checks?RvcRef=${RvcRef}&employeeNum=${employeeNum}&host_url=${host_url}`,
      Type: type,
      Header: { "x-access-token": token },
      Body: orderData
    }

    console.log(data);
    let micros_response;
    try {
      micros_response = await RequestLocalFetchAPI.postMicros(data);

      try {
        //We validate if the micros response is success
        let params_Micros_Respose = {}
        //determines what type of parameter to look for
        if (type == "PUT") {
          params_Micros_Respose = micros_response.data.micros_response.AddToExistingCheckExResponse
        } else {
          params_Micros_Respose = micros_response.data.micros_response.PostTransactionExResponse
        }

        if (params_Micros_Respose.pTotalsResponse.OperationalResult.ErrorCode._text !== undefined && params_Micros_Respose.pTotalsResponse.OperationalResult.ErrorCode._text === "Success") {
          console.log("vamos a actualizar")
          //We add the data that we want to update 
          let data_to_update = {
            micros_reference: {
              checkNum: params_Micros_Respose.pGuestCheck.CheckNum._text,
              checkSeq: params_Micros_Respose.pGuestCheck.CheckSeq._text,
            }
          }
          //We make the update of the order 
          const response = await OrdersFetchAPI.updateOrder(order_id, data_to_update, token);
        }
      } catch (err) {
        console.log(err)
      }
    } catch (err) {
      console.log(err);
    }
  }


  const formatDataEmail = async (email, Datadgi_url, Nowcufe, ccEmail = null) => {
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    let machine = JSON.parse(localStorage.getItem('machine'));
    let business = JSON.parse(localStorage.getItem('business'));
    let logo = localStorage.getItem('businessLogo');
    let user = JSON.parse(localStorage.getItem('user'));
    let url = Datadgi_url != undefined ? Datadgi_url : dgiUrl
    let cufeData = Nowcufe != undefined ? Nowcufe : cufe

    let newShoppingCart = []

    shoppingCart.forEach(item => {
      newShoppingCart.push({
        ...item,
        price: item.price.toFixed(2),
        total: (item.price * item.amount).toFixed(2)
      });
    });

    let dataEmailJson = {
      "cc": ccEmail && ccEmail !== null ? [ccEmail] : [],
      "template": "order-details-smartpay",
      "subject": business.name + " - " + branchoffice.name + "- Factura " + orderNumber,
      "email": email,
      "branchoffice": {
        "name": branchoffice.name
      },
      "emit": {
        "name": branchoffice.fiscal_name,
        "ruc": branchoffice.ruc,
        "dv": branchoffice.dv

      },
      "business": {
        "name": business.name
      },
      "business_color": dataStyleBusiness?.layaoutColor ? dataStyleBusiness.layaoutColor : "#000000",
      "client": {
        "lastname": "",
        "name": dataClientSelected?.billing_name ? dataClientSelected.billing_name : name,
        "ruc": ruc,
        "dv": dv,
      },
      "created_at": getCurrentDateTime(),
      "discount_total": discount.toFixed(2),
      "invoice_total": total.toFixed(2),
      "is_delivery_order": "",
      "items": newShoppingCart,
      "logo_url": logo,
      "payment_method": paymentInfo.payment,
      "sub_total": subtotal.toFixed(2),
      "tax_total": tax.toFixed(2),
      "tips_total": invoiceTips.toFixed(2),
      "transaction_code": orderNumber,
      "dgi_url": url,
      "cufe": cufeData,
      "aditional_info": aditional_data,
      "client_address": addresDescriptionClientFiscal
    }

    console.log("Data to email", dataEmailJson);
    sendMail(dataEmailJson)
  }

  const formatDataOrder = async (detailEMVStreamResponse, register, paymentOverride, clientOverride, extraInfo = {}) => {
    // "Pagar con POS": every gateway/manual success path (BAC, Banesco, Evertech, KinPOS, Credito/
    // Transferencia) converges here before ever building/registering a classic Order - short-circuit
    // that entirely and confirm the pre-pago claim instead, so only the requested lines get marked
    // PAID and the table's account stays open.
    if (posPaymentContext?.payment_attempt_id) {
      const token = localStorage.getItem('x-access-machine-token');
      const paymentMethodInfoForPos = paymentOverride || paymentInfo;
      try {
        LoadingAlert("Confirmando pago", "Registrando el cobro en la mesa...");
        await TableSessionsFetchAPI.confirmPhysicalPayment(
          posPaymentContext.session_uuid,
          posPaymentContext.payment_attempt_id,
          {
            calculation_id: posPaymentContext.calculation_id,
            paymethod_id: getPaymentMethodId(paymentMethodInfoForPos),
            paymenthod_integration_id: getPaymentIntegrationId(paymentMethodInfoForPos),
            gateway_name: paymentMethodInfoForPos?.payment || "",
            gateway_reference: detailEMVStreamResponse,
            // "Personalizar factura" (Nombre/RUC/DV) - sin esto, lo que el cajero cargaba aqui para una
            // mesa nunca llegaba al backend: confirmPhysicalPayment no mandaba nada de esto, se perdia
            // en el estado local del modal.
            ruc: ruc || undefined,
            dv: dv || undefined,
            client_name: name || undefined,
            // Propina de ESTE cobro: sin esto la propina que el cajero cargaba en el Centro de Pagos de una mesa
            // se cobraba en el terminal pero nunca llegaba al backend ni a la factura final de la cuenta.
            tips: Number(invoiceTips) > 0 ? Number(invoiceTips) : undefined
          },
          token
        );
        SuccessAlert("Pago confirmado. La mesa sigue abierta.", "Cobro registrado", "success");
        setShow(false);
        onPosPaymentSettled?.({ success: true });
      } catch (err) {
        const apiError = showApiError(err, {
          title: "No se pudo confirmar el pago",
          message: "El cobro se realizo en el terminal pero no se pudo registrar en la mesa. Avisa a soporte antes de reintentar.",
          context: `payment_attempt_id=${posPaymentContext.payment_attempt_id}`,
          includeSupportId: true,
        }, ErrorAlert);
        // Deliberately does NOT close the modal or clear posPaymentContext here - the charge on the
        // terminal already succeeded, so the waiter needs to keep this open to retry confirming
        // (or fall back to "Cancelar solicitud", which does release the claim) rather than lose
        // track of a card that was already charged.
      }
      return { success: true, registered: false, posPayment: true };
    }

    let user = JSON.parse(localStorage.getItem('user'));
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    let machine = JSON.parse(localStorage.getItem('machine'));
    let client = localStorage.getItem('client') !== null && localStorage.getItem('client') !== undefined ? JSON.parse(localStorage.getItem('client')) : null;
    let selectedWaiter = localStorage.getItem("pos_selected_waiter") !== null && localStorage.getItem("pos_selected_waiter") !== undefined && localStorage.getItem("pos_selected_waiter") !== '' ? JSON.parse(localStorage.getItem("pos_selected_waiter")) : null;
    let paymentMethodInfo = paymentOverride || paymentInfo;
    let selectedClientInfo = clientOverride || dataClientSelected;
    let json = {
      "user_id": user.id,
      "EMVStreamResponse": detailEMVStreamResponse,
      "transaction_code": orderNumber,
      "client_name": name,
      "id_Client": 0,
      "ruc": ruc,
      "dv": dv,
      "localizador": locator,
      "client_phone": client_phone,
      "dgi_qr": "0",
      "Orden": shoppingCart,
      "combos": shoppingCartCombos,
      "Descuento": discount,
      "Total": total.toFixed(2),
      "itbms": tax.toFixed(2),
      "tips": invoiceTips,
      "taxes": taxesArrayAll,
      "subtotal": subtotal.toFixed(2),
      "machine_id": machine.id,
      "branchoffice_id": branchoffice.id,
      "tipoOrden": checkDeliveryOrder,
      "paymenthod_info": paymentMethodInfo,
      "paymethod": getPaymentMethodId(paymentMethodInfo),
      "paymethods": listPaymentReady,
      "discounts": dataDicountApply,
      "paymenthod_integration_id": getPaymentIntegrationId(paymentMethodInfo),
      "table_name": tableInfo.table_name,
      "table_id": tableInfo.table_id,
      "table_code": tableInfo.table_code,
      "discounts": dataDicountApply,
      "parthner_order": parthner_order,
      "aproved_register": register == true ? true : false,
      "aditional_info": aditional_data,
      "client_address": addresDescriptionClientFiscal
    }


    if (eventDataState !== null) {
      json.event_id = eventDataState.id
      json.event_name = eventDataState.name;
    }

    if (client_type !== 0) {
      json.client_type = client_type
    }

    console.log("Json:", json);

    if (addressNowLocation !== null) {
      console.log(addressNowLocation);
      json.direction = {
        id: addressNowLocation.id,
        lng: addressNowLocation.lng,
        lat: addressNowLocation.lat
      };
    }

    if (selectedClientInfo != null && selectedClientInfo.id != undefined && selectedClientInfo.id != null) {
      json.id_Client = selectedClientInfo.id;
      json.client_id = selectedClientInfo.id;
    }

    //We check if the waiter is selected in the local storage
    let selectedWaiterStorage =
      localStorage.getItem("pos_selected_waiter") ? JSON.parse(localStorage.getItem("pos_selected_waiter")) : null;

    const waiterToUse = normalizeWaiter(selectedWaiter) ?? normalizeWaiter(selectedWaiterStorage);
    if (waiterToUse) {
      json.waiter = {
        id: waiterToUse.user_id,
        name: waiterToUse.user_name,
        code: waiterToUse.user_code
      }
    }

    //We check if the payment integration is evertech 
    if (paymentMethodInfo?.integration?.id === 6) {
      if (detailEMVStreamResponse.amounts.tip !== undefined) {
        //IF the payment integration is evertech we search the tip info and add it to the order
        json.tips = detailEMVStreamResponse.amounts.tip.split("$")[1];
      }
    }

    if (yappy_transaction_id != "") {
      json.yappy_transaction_id = yappy_transaction_id
    }

    if (extraInfo?.points_payment) {
      json.points_payment = extraInfo.points_payment
      json.aditional_info = [aditional_data, `Pago con puntos: ${extraInfo.points_payment.points} pts`].filter(Boolean).join(" | ")
      json.note = [json.note, "Pago con puntos"].filter(Boolean).join(" | ")
      json.Orden = Array.isArray(json.Orden) ? json.Orden.map((item) => formatPointsOrderItem(item)) : []
      json.combos = Array.isArray(json.combos) ? json.combos.map((item) => formatPointsOrderItem(item)) : []
      json.Descuento = 0
      json.Total = "0.00"
      json.itbms = "0.00"
      json.tips = 0
      json.subtotal = "0.00"
      json.taxes = [getZeroPointsTax()]
    }

    if (dataPreOrder.pre_Order == true) {
      json.pre_order = true
      json.pre_order_code = dataPreOrder.code
      json.status_id = dataPreOrder.status_id
      json.transaction_code = dataPreOrder.transaction_code
    }

    if (checkDeliveryOrder === "delivery") {
      json.direction = {
        id: 0,
        lng: JSON.parse(localStorage.getItem("addressNowLocation")).lng,
        lat: JSON.parse(localStorage.getItem("addressNowLocation")).lat
      }
    }


    //We check if the order is to delivery
    if (checkDeliveryOrder == "delivery") {
      json.delivery = {
        platform: selectedDeliveryRule != null && selectedDeliveryRule != undefined ? selectedDeliveryRule.fee_type === "kilometer" && selectedDeliveryRule?.distance_source !== "haversine" ? selectedDeliveryRule?.distance_source : "smartpay" : "smartpay",
        value: delivery,
        tax: invoiceTaxDeliveryFee,
        taxes: selectedDeliveryRule != null && selectedDeliveryRule != undefined && selectedDeliveryRule.taxes != null && selectedDeliveryRule.taxes != undefined ? selectedDeliveryRule.taxes : [],
      }

      //We check if the delivery rule is asap to send the order to asap
      if (selectedDeliveryRule != null && selectedDeliveryRule != undefined) {
        if (selectedDeliveryRule.fee_type === "kilometer" && selectedDeliveryRule.distance_source != null && selectedDeliveryRule.distance_source === "asap") {
          json.delivery = {
            ...json.delivery,
            details: {
              "branchoffice_id": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.id,
              "type_id": 1,
              "is_personal": 0,
              "is_oneway": 1,
              "source_address": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.direction,
              "source_seller_name": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.name,
              "source_seller_phone": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.phone,
              "special_inst": "1.⁠ ⁠Obligatorio tomar foto de recogida y de entrega de pedidos ",
              "source_lat": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.lat,
              "source_long": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.lng,
              "desti_lat": JSON.parse(localStorage.getItem("addressNowLocation")).lat,
              "desti_long": JSON.parse(localStorage.getItem("addressNowLocation")).lng,
              "desti_address": JSON.parse(localStorage.getItem("addressNowLocation")).additional_info,
              "desti_customer_name": name !== "" ? name : "Cliente",
              "desti_customer_phone": client_phone !== "" && client_phone !== null && client_phone !== undefined && client_phone !== "" && client_phone !== "0000000" ? client_phone : addressNowLocation.phone,
              "dest_special_inst": "1.⁠ ⁠Obligatorio tomar foto de recogida y de entrega de pedidos ",
              "vehicle_type": "bike"
            }
          }
        } else if (selectedDeliveryRule.fee_type === "kilometer" && selectedDeliveryRule.distance_source != null && selectedDeliveryRule.distance_source === "tookan") {

          json.delivery = {
            ...json.delivery,
            details: {
              "branchoffice_id": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.id,
              //"order_id": orderNumber,
              "special_inst": "Obligatorio tomar foto de recogida y de entrega de pedidos",
              "source_seller_phone": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.phone,
              "source_seller_name": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.name,
              "source_address": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.direction,
              "source_lat": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.lat,
              "source_long": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.lng,
              "customer_email": client.email !== undefined ? client.email : "invitado@invitado.com",
              "desti_customer_phone": client_phone !== "" && client_phone !== null && client_phone !== undefined && client_phone !== "" && client_phone !== "0000000" ? client_phone : addressNowLocation.phone,
              "desti_address": JSON.parse(localStorage.getItem("addressNowLocation")).additional_info,
              "desti_customer_name": name !== "" ? name : "Cliente",
              "desti_lat": JSON.parse(localStorage.getItem("addressNowLocation")).lat,
              "desti_long": JSON.parse(localStorage.getItem("addressNowLocation")).lng,
            }
          }
        }
      }
    }



    if (extraInfo?.kinpos_recovery === true) {
      try {
        const persistedOrder = JSON.parse(localStorage.getItem("OrderDetails"));
        const matchesOrder = persistedOrder
          && String(persistedOrder.transaction_code) === String(extraInfo.order_reference);
        if (matchesOrder) {
          json = {
            ...persistedOrder,
            EMVStreamResponse: detailEMVStreamResponse,
            paymenthod_info: paymentMethodInfo,
            paymethod: getPaymentMethodId(paymentMethodInfo),
            paymenthod_integration_id: getPaymentIntegrationId(paymentMethodInfo),
            aproved_register: true,
          };
        }
      } catch (error) {
        // Continue with the reconstructed React state when the draft is unavailable.
      }
    }

    localStorage.setItem("OrderDetails", JSON.stringify(json));
    if (register == true) {
      return registernewOrder(json);
    }
    return { success: true, registered: false, order: json };
  }



  //Register order aprobed
  const registernewOrder = async (json) => {

    let token = localStorage.getItem('x-access-machine-token')
    LoadingAlert("Registrando orden", "Espere un momento por favor...")


    if (registerTurnOrder == 0) {
      setModalShowErrorRegisterOrder(false)
      let machine = JSON.parse(localStorage.getItem('machine'));
      //We check if the json to register has delivery info
      if (json.delivery != null && json.delivery != undefined) {
        //We prepare the payload for approval workflow
        const approvalPayload = {
          branchoffice_id: json.branchoffice_id,
          order_id: json.transaction_code,
          transaction_code: json.transaction_code,
          metadata: json,
          platform: "ECOMMERCE",
          fulfillment_type: "delivery",
          customer_name: json.client_name || "Cliente",
          customer_phone: json.client_phone || "",
        };

        try {
          // We register the delivery order for approval
          const resp = await DeliveryOrdersFetchAPI.registerDeliveryOrder(
            token,
            approvalPayload
          );

          console.log("la vaina de delivery respondio", resp)
          setDataTransaction_code(resp.data.data.metadata.transaction_code)
          setOrder_id(resp.data.data.order_id)
          setOrderCode(resp.data.data._id)
          setShow(false)
          setTempMethodPayment(0);
          setRegisterTurnOrder(1);
          setResponseQr(true);
          localStorage.setItem("token_session", generateToken())
          localStorage.removeItem("OrderDetails")
          SuccessAlert("Orden de delivery enviada con exito", "Orden generada", "success")
          completeKinposAfterOrderRegistration(json);
          return { success: true, response: resp };
        } catch (err) {
          const apiError = showApiError(err, {
            title: "No se pudo enviar la orden de delivery",
            message: "El backend no pudo registrar la orden pendiente de aprobacion.",
            context: `order=${json?.transaction_code || orderNumber} branch=${json?.branchoffice_id || ""}`,
            includeSupportId: true,
          }, ErrorAlert);

          registerTurnOrder = 0;
          setRegisterTurnOrder(registerTurnOrder)
          setTxtErrorRegisterOrder(apiError.message)
          setModalShowErrorRegisterOrder(true)
          return { success: false, error: apiError };
        }
      } else {

        try {
          const response = await OrderNumberFetchAPI.registerOrder(json, token)
          localStorage.setItem("token_session", generateToken())
          localStorage.removeItem("OrderDetails")
          localStorage.removeItem("voucher_mixto")
          localStorage.removeItem("mixto_payment_approved")

          if (dataClientSelected?.email != undefined && dataClientSelected?.email != null) {
            formatDataEmail(dataClientSelected.email, response.data.data.dgi_qr, response.data.data.cufe)
          }

          setDgiUrl(response.data.data.dgi_qr);
          setCufe(response.data.data.cufe);
          setDataTransaction_code(response.data.data.transaction_code)
          setOrder_id(response.data.data.order_id)
          setOrderCode(response.data.data.order_code)
          setShow(false)
          setResponseQr(true);
          let title = "ORDEN: " + response.data.data.transaction_code
          let text = "Total de la orden: $" + total.toFixed(2)

          if (json.points_payment?.client_id) {
            try {
              const pointsOrderId = response.data.data.id_order || response.data.data.order_id;
              const pointsResponse = await redeemFrequentShopperPoints({
                clientId: json.points_payment.client_id,
                points: json.points_payment.points,
                orderId: pointsOrderId
              });
              if (pointsResponse.data?.data) {
                setdataClientSelected(pointsResponse.data.data);
                localStorage.setItem('client', JSON.stringify(pointsResponse.data.data));
              }
            } catch (pointsError) {
              setPointsRedeemLoading(false);
              showApiError(pointsError, {
                title: "No se pudieron descontar los puntos",
                message: "La orden fue registrada, pero el canje de puntos no se pudo completar.",
                context: `client=${json.points_payment.client_id} points=${json.points_payment.points} order=${response.data.data.id_order || response.data.data.order_id}`,
              }, ErrorAlert);
              return { success: true, response, warning: "POINTS_REDEMPTION_FAILED" };
            }
          }

          if (dataPreOrder.pre_Order == true) { deleteTempPreOrder(response.data.data.transaction_code, response.data.data.order_code) }
          //ConfirmationAlert(title, text, setPageLoader)
          console.log("PRODUCTOS COBRADOS: ", shoppingCart);
          console.log("selectedDeliveryRule: ", selectedDeliveryRule);
          const tieneReserva = shoppingCart.find(item => item.type === "reservable");
          // Retorna true si existe al menos una reserva, false si no
          console.log(tieneReserva);
          if (tieneReserva) {
            // Si hay reservas, se ejecuta esta lógica
            console.log("Hay reserva");
            putOrderReservedCode(response.data.data.order_id, response.data.data.transaction_code, response.data.data.id_order, tieneReserva, {
              isPreOrderPayment: json.pre_order === true,
            })
          } else {
            console.log("No hay reserva");
            printOrder(response.data.data.order_id, response.data.data.transaction_code, undefined, {
              isPreOrderPayment: json.pre_order === true,
            });
          }


          setTempMethodPayment(0);
          setRegisterTurnOrder(1);

          //type integration micros
          if (response.data.data.micros_params != null) {
            //params micros
            let micros_params = response.data.data.micros_params;
            let ip = micros_params.localMicrosServerIp
            if (dataPreOrder.pre_Order == true) {

              if (dataReferenceOrderMicros.checkNum != "" && dataReferenceOrderMicros.checkSeq != "") {
                handlerComparativeNewData(ip, micros_params.RvcRef, micros_params.employeeNum, micros_params.host_url, micros_params, token, response.data.data.order_id);
              } else {
                //createCheckMicrosOrderLocal(ip, micros_params.RvcRef, micros_params.employeeNum, micros_params.host_url, micros_params, token, response.data.data.order_id, "POST");
                validTotalsMicros(ip, micros_params.RvcRef, micros_params.employeeNum, micros_params.host_url, micros_params, token, order_id, "POST", micros_params)
              }
            } else {
              //createCheckMicrosOrderLocal(ip, micros_params.RvcRef, micros_params.employeeNum, micros_params.host_url, micros_params, token, response.data.data.order_id, "POST");
              validTotalsMicros(ip, micros_params.RvcRef, micros_params.employeeNum, micros_params.host_url, micros_params, token, order_id, "POST", micros_params)
            }
          } else {
            console.log("no hay parametros de micros");
          }

          //We show a success message when the order is approved when the type of payment is credit 
          if (json.points_payment?.client_id) {
            SuccessAlert("Puntos canjeados correctamente", "Orden generada", "success")
          } else if (paymentInfo.payment_id === 10) {
            SuccessAlert("Orden a credito generada", "Orden generada", "success")
          } else {
            SuccessAlert("Orden registrada con exito", "Orden generada", "success")
          }
          setPointsRedeemLoading(false);
          //We remove the selected waiter when the order is registered
          localStorage.removeItem("pos_selected_waiter_id")
          localStorage.removeItem("pos_selected_waiter")
          completeKinposAfterOrderRegistration(json);
          return { success: true, response };
        } catch (err) {
          //valid to id of transaction 

          const apiError = normalizeApiError(err, {
            title: "No se pudo registrar la orden",
            message: "El backend rechazo el registro de la orden.",
            context: `order=${json?.transaction_code || orderNumber}`,
          });

          if (apiError.message.includes("ocupada")) {
            registerTurnOrder = 0;
            setRegisterTurnOrder(registerTurnOrder)
            ErrorAlert(apiError.message, apiError.title, apiError.icon, undefined, { detail: apiError.detail })
            setTxtErrorRegisterOrder(apiError.message)
            setModalShowErrorRegisterOrder(true)
            return { success: false, error: apiError };
          } else {
            try {
              let token = localStorage.getItem('x-access-machine-token');
              const response = await MachinesFetchAPI.lastOrderMachine(machine.id, token);

              if (response.data.last_order._id == lastOrder_id) {
                console.log("La transaccion no habia sido regitrada")
                console.log(err);
                registerTurnOrder = 0;
                setRegisterTurnOrder(registerTurnOrder)
                ErrorAlert(apiError.message, apiError.title, apiError.icon, undefined, { detail: apiError.detail })
                setTxtErrorRegisterOrder(apiError.message)
                setModalShowErrorRegisterOrder(true)
                localStorage.removeItem("pos_selected_waiter_id")
                localStorage.removeItem("pos_selected_waiter")
                return { success: false, error: apiError };
              } else {
                console.log("La transaccion ya habia sido regitrada")
                setDataTransaction_code(response.data.last_order.transaction_code);
                setOrder_id(response.data.last_order.order_id)
                setOrderCode(response.data.last_order.order_code)
                localStorage.setItem("token_session", generateToken())
                localStorage.removeItem("OrderDetails")
                localStorage.removeItem("voucher_mixto")
                localStorage.removeItem("mixto_payment_approved")
                localStorage.removeItem("pos_selected_waiter_id")
                localStorage.removeItem("pos_selected_waiter")
                console.log(response);
                setShow(false)
                setResponseQr(true);
                let title = "ORDEN: " + response.data.last_order.transaction_code
                let text = "Total de la orden: $" + total.toFixed(2)

                if (dataPreOrder.pre_Order == true) { deleteTempPreOrder(response.data.last_order.transaction_code, response.data.last_order.order_code) }
                //ConfirmationAlert(title, text, setPageLoader)
                printOrder(response.data.last_order.order_id, response.data.last_order.transaction_code, undefined, {
                  isPreOrderPayment: dataPreOrder.pre_Order === true,
                });
                setTempMethodPayment(0);
                setRegisterTurnOrder(1);

                //We show a success message when the order is approved when the type of payment is credit 
                if (json.points_payment?.client_id) {
                  SuccessAlert("Orden registrada con pago por puntos", "Orden generada", "success")
                } else if (paymentInfo.payment_id === 10) {
                  SuccessAlert("Orden a credito generada", "Orden generada", "success")
                } else {
                  SuccessAlert("Orden registrada con exito", "Orden generada", "success")
                }
                localStorage.removeItem("pos_selected_waiter_id")
                localStorage.removeItem("pos_selected_waiter")
                completeKinposAfterOrderRegistration(json);
                return { success: true, response, recovered: true };
              }

            } catch (err) {
              const recoveryError = normalizeApiError(err, {
                title: "No se pudo verificar la ultima orden",
                message: apiError.message,
                context: `machine=${machine?.id || ""} order=${json?.transaction_code || orderNumber}`,
              });

              registerTurnOrder = 0;
              setRegisterTurnOrder(registerTurnOrder)
              ErrorAlert(recoveryError.message, recoveryError.title, recoveryError.icon, undefined, { detail: recoveryError.detail })
              setTxtErrorRegisterOrder(recoveryError.message)
              setModalShowErrorRegisterOrder(true)
              localStorage.removeItem("pos_selected_waiter_id")
              localStorage.removeItem("pos_selected_waiter")
              return { success: false, error: recoveryError };
            }
          }
        }
      }
    } else {
      console.log("Hay una orden en proceso");
      return { success: false, reason: "ORDER_REGISTRATION_IN_PROGRESS" };
    }
  }

  const handleKinposResult = async (result) => {
    if (result.status === "pending") {
      setKinposPaymentPending(true);
      return;
    }

    if (result.status === "uncertain") {
      setKinposPaymentPending(true);
      setShowModalProcess(false);
      setPaymentApproval({ status: 0, description: "Resultado KinPOS pendiente de confirmacion" });
      showKinposFailure(result);
      return;
    }

    if (result.status !== "approved") {
      setPaymentApproval({ status: 2, description: result.message || "Pago no aprobado" });
      setShowModalProcess(false);
      showKinposFailure(result);
      kinposPaymentBridge.complete(result.request_id);
      setKinposPaymentPending(false);
      setBotonDeshabilitado(false);
      return;
    }

    const selectedPayment = findKinposPaymentMethodById(
      paymentMethod,
      result.request.payment_method_id
    ) || (isKinposPaymentMethod(paymentInfo) ? paymentInfo : null);

    if (!selectedPayment) {
      kinposPaymentBridge.markProcessingFailed(result.request_id);
      setShowModalProcess(false);
      ErrorAlert(
        "KinPOS aprobo el cobro, pero el metodo de pago ya no esta disponible en esta maquina. Verifica la configuracion antes de registrar la orden.",
        "Pago cobrado pendiente de registro",
        "warning"
      );
      return;
    }

    const actualPayment = resolveActualKinposPaymentMethod(
      selectedPayment,
      result.transaction?.card_network,
      paymentMethod
    );
    const selectedPaymentId = getPaymentMethodId(selectedPayment);
    const actualPaymentId = getPaymentMethodId(actualPayment);
    const networkPaymentId = getKnownKinposCardNetworkPaymentMethodId(
      result.transaction?.card_network
    );
    if (networkPaymentId !== null && selectedPaymentId !== networkPaymentId) {
      console.warn("KinPOS card network differs from the selected payment method", {
        request_id: result.request_id,
        selected_payment_method_id: selectedPaymentId,
        resolved_payment_method_id: actualPaymentId,
        card_network: result.transaction.card_network,
      });
    }

    const paymentRecord = {
      ...toKinposPaymentRecord(result),
      payment_method_id: actualPaymentId,
    };
    setPaymentApproval({ status: 1, description: "APROBADO" });

    const registration = await formatDataOrder(
      paymentRecord,
      true,
      actualPayment,
      undefined,
      {
        kinpos_recovery: result.request.restored === true,
        order_reference: result.request.order_reference,
      }
    );

    if (registration?.success === true) {
      kinposPaymentBridge.complete(result.request_id);
      setShow(false);
      setShowModalProcess(false);
      setKinposPaymentPending(false);
      setBotonDeshabilitado(false);
    } else {
      kinposPaymentBridge.markProcessingFailed(result.request_id);
      setShowModalProcess(false);
      setKinposPaymentPending(true);
      ErrorAlert(
        "La tarjeta fue aprobada, pero la orden no pudo registrarse. No vuelvas a cobrar; SmartPay conservara el resultado para recuperarlo.",
        "Pago cobrado pendiente de registro",
        "warning"
      );
    }
  };

  kinposResultHandlerRef.current = handleKinposResult;

  useEffect(() => {
    if (!paymentMethod.length) return undefined;
    return kinposPaymentBridge.subscribe(
      "full",
      (result) => kinposResultHandlerRef.current?.(result)
    );
  }, [paymentMethod.length]);

  useEffect(() => kinposPaymentBridge.subscribePendingState((pendingPayment) => {
    setKinposPaymentPending(pendingPayment?.mode === "full");
  }), []);

  useEffect(() => {
    const pendingPayment = kinposPaymentBridge.getPendingPayment();
    if (!paymentMethod.length || pendingPayment?.mode !== "full") return;

    setKinposPaymentPending(true);
    Promise.resolve(kinposPaymentBridge.recover()).finally(() => {
      const currentPendingPayment = kinposPaymentBridge.getPendingPayment();
      setKinposPaymentPending(currentPendingPayment?.mode === "full");
    });
  }, [paymentMethod]);

  useEffect(() => {
    const pendingPayment = kinposPaymentBridge.getPendingPayment();
    if (pendingPayment?.mode === "mixed") {
      setShow(true);
      setShowModalMixto(true);
    }
  }, []);

  //Put order with product reserved
  const putOrderReservedCode = async (id_Orden_Imprimir, transaction_code, id_order_mysql, group, printOptions = {}) => {
    try {
      let token = localStorage.getItem('x-access-machine-token');
      let data = {
        "status": "redeemed",
        "order_id": id_order_mysql
      }
      const response = await ReservationFetchAPI.putReservation(group.group_id, data, token)

      printOrder(id_Orden_Imprimir, transaction_code, undefined, printOptions);
    } catch (err) {
      console.log(err);
      printOrder(id_Orden_Imprimir, transaction_code, undefined, printOptions);
    }
  }


  //print order
  const printOrder = async (id_Orden_Imprimir, transaction_code, micros, options = {}) => {
    let type_ticket = ""
    let imprimir_comanda = ""
    let ip_print = "localhost"
    const isPreOrderPayment = shouldUsePreOrderPaymentPrintMode({
      explicitPreOrderPayment: options.isPreOrderPayment,
      preOrderInvoice,
      dataPreOrder,
    });
    const shouldPrintKitchen = !isPreOrderPayment || hasPendingKitchenItems(shoppingCart, shoppingCartCombos, {
      printers,
    });

    if (localStorage.getItem("ip_printer") != "" && localStorage.getItem("ip_printer") != undefined && localStorage.getItem("ip_printer") != null) {
      ip_print = localStorage.getItem("ip_printer")
    }

    if (!shouldPrintKitchen) {
      //type_ticket = "factura_precuenta"
      type_ticket = "factura"
      imprimir_comanda = "no"
    } else {
      type_ticket = "factura"
      imprimir_comanda = "si"
    }

    let arrayPrinters = []
    if (!shouldPrintKitchen) {
      printers.forEach((printer) => {
        if (printer.printer_type == "Tickets") {
          arrayPrinters.push(printer)
        }
      });

    } else {
      printers.forEach((printer) => {
        arrayPrinters.push(printer)
      });
    }

    let JsonImprimir = [{
      "type_ticket": type_ticket,
      "Printers": arrayPrinters,
      "Nombre_maquina_impresora": infoPrinter.printer_ticket,
      "Nombre_cocina_impresora": infoPrinter.printer_comanda,
      "Nombre_zebra_impresora": infoPrinter.printer_zebra,
      "PRINTER_IP": infoPrinter.printer_ip,
      "Id_Orden_Imprimir": id_Orden_Imprimir,
      "token": localStorage.getItem('x-access-machine-token'),
      "transaction_code": transaction_code,
      "amount_item": shoppingCart.length,
      "imprimir_comanda": imprimir_comanda,
    }]


    printOrderData(JsonImprimir)

    try {
      const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, localStorage.getItem('x-access-machine-token'));

      if (micros == true) {
        let dataRequestMicros = {
          "body": JsonImprimir, "method": "POST", "url": "http://localhost:9090/impresion"
        }
        const response = await RequestAlohaFetchAPI.requestLocalIp(dataRequestMicros, response_machine.data.data.windows_ip)
      } else {
        if (ip_print == "localhost") {
          const response = await PrinterFetchAPI.printOrder(ip_print, JsonImprimir, response_machine.data.data.windows_ip)
        } else {
          const response = await PrinterFetchAPI.printByServerMiddle(ip_print, JsonImprimir)
        }
      }


    } catch (err) {
      console.log(err);
    }
  }

  //delete pre order
  const deleteTempPreOrder = async (transaction_code, orden_code, pre_order_code) => {

    let token = localStorage.getItem('x-access-machine-token');
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'));
    let business = JSON.parse(localStorage.getItem('business'));
    let user = JSON.parse(localStorage.getItem('user'));


    let business_code = business.code
    let branch_code = branchoffice.code
    let order_code_temp = pre_order_code !== undefined ? pre_order_code : dataPreOrder.code

    if (codeParthner != 0) {
      business_code = codeParthner.business_code
      branch_code = codeParthner.branchoffice_code
    }




    let jsonUpdate = {
      "order_code": order_code_temp,
      "business_code": business_code,
      "branchoffice_code": branch_code,
      "deleted": false,
      "status": 3,
      "user_id": user.id,
      "finished_order_transaction_code": transaction_code,
      "finished_order_code": orden_code,
      "justification": dataPreOrder?.orde?.justification || "",
    }

    console.log("dataPreOrder", dataPreOrder);
    try {

      //We save the preorder
      await DeletedTempOrdersFetchAPI.newDeletedTempOrder(jsonUpdate, token);

      const response = await PreOrderFetchAPI.deletePreOrder(jsonUpdate, token)

    } catch (err) {
      console.log(err);
    }

  }

  //get last order in this machine
  const lastOrderMachineRequest = async () => {
    let token = localStorage.getItem('x-access-machine-token');
    try {
      const response = await MachinesFetchAPI.lastOrderMachine(machine.id, token);

      setLastOrder_id(response.data.last_order._id)

    } catch (err) {
      console.log(err)
    }
  }

  //function to get data when load the component
  const functionGetRequest = async (turn) => {
    //Variables 
    let token = localStorage.getItem('x-access-machine-token');
    let branchoffice = localStorage.getItem('branchoffice') !== '' ? JSON.parse(localStorage.getItem('branchoffice')) : ''
    let machine = localStorage.getItem('machine') !== '' ? JSON.parse(localStorage.getItem('machine')) : ''
    try {
      //We check the data on the local storage
      if (machine !== '' && machine !== null && machine !== undefined) {
        getPaymentMethod(machine.id, token)
        if (turn == 1) {
          //getOrderNumber(branchoffice.id, token)
        }

      }

      //------------------------------------------------

    } catch (err) {
      console.log(err);
    }
  }

  const getInventory = async () => {

    let array = []
    shoppingCart.forEach(product => {
      if (product.group_id && product.group_id != null) {
        if (product.group_type == "limited") {
          array.push({ "group_id": product.group_id })
        }
      }
    });
    let data = { "products": array }

    console.log("DATOS PRODUCTOS CON INVENTARIO EN LA SHOPPINDCART", data);
    if (array.length > 0) {
      try {
        const response = await InventoryFechtAPI.getInventoryByProducts(data, localStorage.getItem("x-access-machine-token"))
        let dataInventory = response.data.inventory

        console.log("dataInventory", dataInventory);

        let arrayProducts = []
        shoppingCart.forEach((product, index) => {
          dataInventory.forEach(group => {
            console.log("group", group);
            if (group.group_id === product.group_id) {

              let filter = shoppingCart.filter(group => group.group_id == product.group_id)

              let amountNow = 0
              if (filter.length > 0) {
                filter.forEach(groupFilter => { amountNow = (amountNow + groupFilter.amount) })

              } else {
                amountNow = product.amount
              }


              let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
              let dataFilterBranch = group.branchoffices.find(branch => branch.branchoffice_id == branchoffice.id)

              console.log("dataFilterBranch", dataFilterBranch);

              if (dataFilterBranch == undefined) {
                validQuantity(group.quantity)
              } else {
                if (localStorage.getItem("warehouse") == "" || localStorage.getItem("warehouse") == null || localStorage.getItem("warehouse") == undefined) {
                  let warehouselocal = JSON.parse(localStorage.getItem('warehouse'))

                  let findwarehouse = dataFilterBranch.warehouses.find(warehouse => warehouse.warehouse_id == warehouselocal.id)
                  if (findwarehouse == undefined) {
                    validQuantity(dataFilterBranch.quantity)
                  } else {
                    console.log("findwarehouse", findwarehouse);
                    validQuantity(findwarehouse.quantity)
                  }
                } else {
                  validQuantity(dataFilterBranch.quantity)
                }

              }


              function validQuantity(quantity) {
                if (amountNow <= quantity) {

                } else {
                  let dataProduct = product
                  dataProduct.quantity = quantity
                  dataProduct.index = index

                  arrayProducts.push(dataProduct)

                }
              }

            }
          })


        });

        if (arrayProducts.length > 0) {

          shoppingCart.forEach((item) => {
            let filter = arrayProducts.filter(group => group.group_id == item.group_id)
            let quantity = 0
            if (filter != undefined && filter.length > 0) {
              filter.forEach(group => { quantity = (group.quantity) })
              item.quantity = quantity
            }
          })

          setEventHandler(1)

          ErrorAlert("", "Hay productos que requieren ser revisados", "warning")
          //setdataProductInventoryFauld(arrayProducts)
          //setShowModalDetailInventoryByGroup(true)
        } else {
          nextTransactionStep();
        }
      } catch (err) {
        nextTransactionStep();
        console.log(err);
      }
    } else {
      nextTransactionStep();
    }
  }

  //continue with the flow of the transaction
  function nextTransactionStep() {
    openPaymentFlow()
  }

  const handlePayButtonClick = () => {
    if (hasPendingPreOrderCartChanges === true) {
      ErrorAlert(
        "Debes actualizar la precuenta antes de continuar al pago.",
        "Actualiza la precuenta",
        "warning"
      )
      return
    }

    getInventory()
    console.log("Selected PreOrder:", selectPreOrder)
  }



  const openPaymentFlow = () => {
    formatDataOrder(0)
    setShow(true)
    setPendingOpenPayment(false)
    getPrinter()
    setBotonDeshabilitado(false)
    setPaymentInfo({ payment: "" })
    lastOrderMachineRequest()
    functionGetRequest()
  }

  const handleConfirmWaiter = (waiter) => {
    setSelectedWaiter(waiter ?? null)

    if (pendingOpenPayment === true) {
      openPaymentFlow()
    }
  }


  // If we are paying a PreOrder that already has a waiter, prefill it.
  // This should override the "last cashier selection" so the order keeps its original waiter unless changed.
  useEffect(() => {
    if (!selectPreOrder || selectPreOrder.order === "") return;
    let waiterData = selectPreOrder.waiter ?? selectPreOrder
    const preWaiter = normalizeWaiter(waiterData ?? selectPreOrder.order?.waiter ?? null)
    if (!preWaiter) {
      setSelectedWaiter(null)
      localStorage.removeItem('pos_selected_waiter_id')
      localStorage.removeItem('pos_selected_waiter')

      return
    }

    localStorage.setItem('pos_selected_waiter_id', String(preWaiter.user_id))
    localStorage.setItem('pos_selected_waiter', JSON.stringify(preWaiter))
    setSelectedWaiter({
      id: preWaiter.user_id,
      name: preWaiter.user_name,
      code: preWaiter.user_code
    })
  }, [selectPreOrder])


  useEffect(() => {
    if (recoveryOrderApproved == true) {
      let dataOrderRecovery = JSON.parse(localStorage.getItem("OrderDetails"))
      if (!dataOrderRecovery) return;
      if (dataOrderRecovery?.waiter) {
        setSelectedWaiter({
          id: dataOrderRecovery.waiter.id,
          name: dataOrderRecovery.waiter.name,
          code: dataOrderRecovery.waiter.code
        })
      }
      //setShow(true)
      setInvoiceTips(dataOrderRecovery.tips)
      setShoppingCart(dataOrderRecovery.Orden);
      setShoppingCartCombos(dataOrderRecovery.combos || []);
      calculateInvoiceTotals(dataOrderRecovery.Orden, dataOrderRecovery.combos)
      const pendingKinposPayment = kinposPaymentBridge.getPendingPayment();
      const canRetryKinposRegistration = isKinposRegistrationRecoveryDraft(
        pendingKinposPayment,
        dataOrderRecovery
      );
      if (!pendingKinposPayment || canRetryKinposRegistration) {
        setOrderToRecovery(dataOrderRecovery)
      }
      /*setTimeout(() => {
        registernewOrder(dataOrderRecovery);
      }, [1500])*/

    }
  }, [recoveryOrderApproved]);

  useEffect(() => {
    (async () => {
      functionGetRequest(1)
    })();
  }, [])

  useEffect(() => {
    let timer = 0
    if (statusRequestYappy == true) {
      timer = setInterval(async () => getYappyTransaction(), 5000); //INTERVAL GET YAPPY STATUS TRANSACTION

      return () => clearInterval(timer)
    } else {
      return () => clearInterval(timer) //CLEAR INTERVAL
    }

  }, [statusRequestYappy, dataYappy]);

  //Hook of the webhook of evertech transactions place to play
  useEffect(() => {
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    //We verify the machine code 
    if (machine !== undefined && machine !== null && branchoffice !== undefined && branchoffice !== null) {
      // Connection with the sockets server
      const socket = Socket({ "machine_code": machine.code, "branchoffice_code": branchoffice.code });

      //We listen the yappy order
      socket.on("yappyorder", (data) => {
        let yappyTransactionId = localStorage.getItem('yappy_transaction_id');
        console.log(data);
        //We check if the transaction is the same
        if (yappyTransactionId === data.yappy_transaction_id) {
          setRegisterTurnOrder(1);
          if (hasPreOrderCode(data.pre_order_code)) {
            deleteTempPreOrder(data.transaction_code, data.code, data.pre_order_code)
          }

          setDataTransaction_code(data.transaction_code)
          setOrder_id(data.order_id)
          setOrderCode(data._id)
          setShow(false)
          setTempMethodPayment(0);
          setRegisterTurnOrder(1);
          setResponseQr(true);
          //We print the order
          printOrder(data._id, data.transaction_code, undefined, {
            isPreOrderPayment: hasPreOrderCode(data.pre_order_code),
          });
          //We clear the session
          localStorage.setItem("token_session", generateToken())
          localStorage.removeItem("OrderDetails")
          localStorage.setItem("yappy_transaction_id", "")
        }

      })

      return () => {
        socket.disconnect();
      }
    }
  }, [statePayment, paymentApproval])

  const [fullscreen, setFullscreen] = useState(true);
  const pendingKinposPayment = kinposPaymentBridge.getPendingPayment();
  // El bridge es un singleton fuera de React: si el void/anulacion que lo dejo "pendiente" se
  // resuelve desde OTRO componente (ej. ModalReturn haciendo una devolucion), nada obliga a este
  // componente hermano a re-renderizar para enterarse - el boton "Pagar" se quedaba pegado en
  // "Anulacion KinPOS pendiente" aunque el bridge ya hubiera limpiado el estado. Se sondea (mismo
  // patron que ya usa el polling de Yappy mas arriba) solo mientras haya algo pendiente, y se
  // detiene solo en cuanto se resuelve.
  const [, forceKinposPendingRefresh] = useState(0);
  useEffect(() => {
    if (!pendingKinposPayment) return undefined;
    const timer = setInterval(() => forceKinposPendingRefresh((tick) => tick + 1), 1500);
    return () => clearInterval(timer);
  }, [Boolean(pendingKinposPayment)]);
  const preserveKinposRecoveryDraft = isKinposRegistrationRecoveryDraft(
    pendingKinposPayment,
    orderToRecovery
  );
  const canResumeKinposRegistration = pendingKinposPayment
    && (
      (pendingKinposPayment.mode === "full" && pendingKinposPayment.state === "registration_failed")
      || (pendingKinposPayment.mode === "mixed" && pendingKinposPayment.state === "awaiting_registration")
    );
  const resumeKinposRegistration = () => {
    if (pendingKinposPayment?.mode === "mixed") {
      setShow(true);
      setShowModalMixto(true);
      return;
    }

    try {
      const persistedOrder = JSON.parse(localStorage.getItem("OrderDetails"));
      if (persistedOrder) {
        setOrderToRecovery(persistedOrder);
        setRecoveryOrderApproved(true);
      }
    } catch (error) {
      ErrorAlert("No se pudo recuperar el borrador de la orden.", "Recovery KinPOS", "warning");
    }
  };

  // Salida de emergencia para un pago "full" que quedo ATRAPADO (ej. el PAX se apago en pleno cobro y
  // el pendiente se restaura en cada apertura sin que llegue nunca un resultado final). Solo se ofrece si
  // el pendiente se restauro tras reiniciar o ya paso el tiempo razonable de un cobro en curso, para no
  // descartar un cobro que el terminal todavia esta procesando.
  const KINPOS_STUCK_DISCARD_AFTER_MS = 120000;
  const canDiscardStuckKinposPayment = Boolean(pendingKinposPayment)
    && !canResumeKinposRegistration
    && pendingKinposPayment.mode === "full"
    && (
      pendingKinposPayment.restored
      || Date.now() - Number(pendingKinposPayment.created_at || 0) > KINPOS_STUCK_DISCARD_AFTER_MS
    );
  const discardStuckKinposPayment = async () => {
    const pending = kinposPaymentBridge.getPendingPayment();
    if (!pending || pending.mode !== "full") return;

    const confirmation = await Swal.fire({
      icon: "warning",
      title: "Descartar pago KinPOS pendiente",
      html: `<div style="text-align:left;font-size:14px;line-height:1.5">
        <p>Se liberará el botón de pago en este dispositivo.</p>
        <p style="color:#b42318">Descartarlo NO reversa ni registra el cobro. Verifica en el voucher o reporte del terminal que la tarjeta no fue cobrada (o que ya fue registrada/conciliada) antes de continuar.</p>
      </div>`,
      showCancelButton: true,
      confirmButtonText: "Sí, descartar",
      cancelButtonText: "Cancelar",
      focusCancel: true,
      allowOutsideClick: false,
    });
    if (!confirmation.isConfirmed) return;

    // Constancia local (ultimos 20): que se descarto, cuando y por quien.
    try {
      const user = JSON.parse(localStorage.getItem("user") || "null");
      const history = JSON.parse(localStorage.getItem("smartpay.kinpos.discarded.v1") || "[]");
      history.push({
        discarded_at: new Date().toISOString(),
        discarded_by: user?.name || user?.user_name || user?.id || null,
        request_id: pending.request_id || null,
        order_reference: pending.order_reference || null,
        pending_state: pending.state || null,
        pending_created_at: pending.created_at || null,
      });
      localStorage.setItem("smartpay.kinpos.discarded.v1", JSON.stringify(history.slice(-20)));
    } catch (error) {
      // La constancia es mejor esfuerzo: no debe impedir liberar el dispositivo.
    }

    kinposPaymentBridge.discardPendingPayment(pending.request_id);
    forceKinposPendingRefresh((tick) => tick + 1);
    SuccessAlert("Pago pendiente descartado.");
  };

  // "Pagar con POS": lets the waiter back out of the request (e.g. the terminal charge failed and
  // they don't want to retry right now) instead of leaving the claim locked until the backend's own
  // claim TTL expires - see releasePaymentClaim on the backend.
  const releasePosPaymentRequest = async () => {
    if (!posPaymentContext?.payment_attempt_id) return;
    const token = localStorage.getItem('x-access-machine-token');
    try {
      await TableSessionsFetchAPI.releasePhysicalPayment(
        posPaymentContext.session_uuid,
        posPaymentContext.payment_attempt_id,
        "Cobro cancelado en el POS",
        token
      );
    } catch (err) {
      // Best-effort - the backend's own claim TTL will release it eventually either way.
    }
    setShow(false);
    onPosPaymentSettled?.({ success: false, cancelled: true });
  };



  const paySummaryLines = (
    <>
      <RenderIf isTrue={!isPointsPayment}>
        <div className="pay-mdl-line">
          <span>Descuento</span>
          <span className="pay-mdl-line-val">$<span className="amount" id="discount">{discount.toFixed(2)}</span></span>
        </div>

        <RenderIf isTrue={checkDeliveryOrder === "delivery"}>
          <div className="pay-mdl-line">
            <span>Delivery</span>
            <span className="pay-mdl-line-val">$<span className="amount" id="delivery">{delivery.toFixed(2)}</span></span>
          </div>
        </RenderIf>

        <div className="pay-mdl-line">
          <span>ITBMS</span>
          <span className="pay-mdl-line-val">$<span className="amount" id="tax">{tax.toFixed(2)}</span></span>
        </div>
      </RenderIf>

      {isPointsPayment ? (
        <div className="pay-mdl-line pay-mdl-line--total">
          <span>Total puntos</span>
          <span className="pay-mdl-line-val"><span className="amount" id="total">{pointsTotal}</span> pts</span>
        </div>
      ) : (
        <>
          <div className="pay-mdl-line">
            <span>Subtotal</span>
            <span className="pay-mdl-line-val">$<span className="amount" id="subtotal">{subtotal.toFixed(2)}</span></span>
          </div>

          <div className="pay-mdl-line pay-mdl-line--total">
            <span>Total a pagar</span>
            <span className="pay-mdl-line-val">$<span className="amount" id="total">{total.toFixed(2)}</span></span>
          </div>

          {invoiceTips > 0 ? (
            <div className="pay-mdl-line pay-mdl-line--tip">
              <span>Total + propina</span>
              <span className="pay-mdl-line-val">$<span className="amount">{totaltopay.toFixed(2)}</span></span>
            </div>
          ) : null}
        </>
      )}
    </>
  );


  const [activePanel, setActivePanel] = useState(null);
  const facturaSet = Boolean(ruc) && ruc !== "0";
  const meseroSet = selectedWaiter != null;
  const propinaSet = invoiceTips > 0;
  const localizadorSet = Boolean(locator);
  const paisanitosSet = Boolean(client_phone);

  useEffect(() => {
    if (!show) return;
    const onKey = (e) => {
      if (e.key !== "Escape") return;
      setShow(false);
      onDismiss?.();
    };
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener("keydown", onKey);
    };
  }, [show]);

  useEffect(() => {
    if (!showEditBill) return;
    const onKey = (e) => e.key === "Escape" && handleEditBillClose();
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener("keydown", onKey);
    };
  }, [showEditBill]);
  return (
    <>

      <div className={canDiscardStuckKinposPayment ? "d-flex flex-column w-100" : undefined} style={canDiscardStuckKinposPayment ? undefined : { display: "contents" }}>
        <button
          className='btn btn-success bg-brand-smartpay px-5 btn-lg w-100 border-0'
          disabled={Boolean(pendingKinposPayment) && !canResumeKinposRegistration}
          onClick={canResumeKinposRegistration ? resumeKinposRegistration : handlePayButtonClick}>
          <strong className='fs-label-1'>{pendingKinposPayment ? canResumeKinposRegistration ? "Continuar registro KinPOS" : getKinposPendingOperationLabel(pendingKinposPayment) : isPointsPayment ? "Pagar con puntos: " : "Pagar: "}</strong>
          {!pendingKinposPayment && <strong className='fs-label-1' translate='no'>{isPointsPayment ? `${pointsTotal} pts` : `$${total.toFixed(2)}`}</strong>}
        </button>
        {canDiscardStuckKinposPayment && (
          <button
            type="button"
            className="btn btn-link text-danger btn-sm w-100 mt-1 p-0"
            onClick={discardStuckKinposPayment}>
            ¿Pago trabado? Descartar pendiente
          </button>
        )}
      </div>

      {/* ==================================================================
    CENTRO DE PAGOS — pay-mdl-*
   ================================================================== */}
      {show && createPortal(
        <div className="pay-mdl-overlay" onClick={() => { setShow(false); onDismiss?.(); }}>
          <div
            className="pay-mdl-dialog"
            role="dialog"
            aria-modal="true"
            aria-label="Centro de Pagos"
            onClick={(e) => e.stopPropagation()}
          >

            {/* ---------------- HEADER ---------------- */}
            <header className="pay-mdl-head">
              <i className="uil uil-transaction" />
              <h2 className="pay-mdl-title">Centro de Pagos</h2>
            </header>

            {/* ---------------- BODY ---------------- */}
            <div className="pay-mdl-body">

              {/* ---------------- AVISO DE COBRO DESDE MESA ---------------- */}
              {posPaymentContext?.payment_attempt_id ? (
                <div className="pay-mdl-alert">
                  <span className="pay-mdl-alert-text">
                    <i className="bi bi-credit-card-2-front" /> Cobro solicitado desde mesa {posPaymentContext.table_name || ""} — la cuenta seguirá abierta al confirmar.
                  </span>
                  <button type="button" className="pay-mdl-alert-btn" onClick={releasePosPaymentRequest}>
                    Cancelar solicitud
                  </button>
                </div>
              ) : null}

              {/* ---------------- CHIPS DE SECCIONES ---------------- */}
              <div className="pay-mdl-chips">
                <button
                  type="button"
                  className={`pay-mdl-chip ${facturaSet ? "is-set" : ""}`}
                  onClick={handleEditBillShow}
                >
                  <i className="uil uil-file-alt" />
                  <span className="pay-mdl-chip-text">
                    <span className="pay-mdl-chip-key">Factura</span>
                    <span className="pay-mdl-chip-val">{facturaSet ? `${name} · ${ruc}` : "Cliente genérico"}</span>
                  </span>
                </button>



                <RenderIf isTrue={!isPointsPayment && showModuleLocator == true}>
                  <button
                    type="button"
                    className={`pay-mdl-chip ${localizadorSet ? "is-set" : ""}`}
                    onClick={() => setActivePanel("localizador")}
                  >
                    <i className="uil uil-map-marker" />
                    <span className="pay-mdl-chip-text">
                      <span className="pay-mdl-chip-key">Localizador</span>
                      <span className="pay-mdl-chip-val">{localizadorSet ? locator : "Sin número"}</span>
                    </span>
                  </button>
                </RenderIf>

                <RenderIf isTrue={!isPointsPayment && business.id == 13}>
                  <button
                    type="button"
                    className={`pay-mdl-chip ${paisanitosSet ? "is-set" : ""}`}
                    onClick={() => setActivePanel("paisanitos")}
                  >
                    <i className="uil uil-users-alt" />
                    <span className="pay-mdl-chip-text">
                      <span className="pay-mdl-chip-key">Paisanitos</span>
                      <span className="pay-mdl-chip-val">{paisanitosSet ? client_phone : "Sin cliente"}</span>
                    </span>
                  </button>
                </RenderIf>

                <RenderIf isTrue={localStorage.getItem("branchoffice") && JSON.parse(localStorage.getItem("branchoffice")).waiters_enabled === 1}>
                  <button
                    type="button"
                    className={`pay-mdl-chip ${meseroSet ? "is-set" : ""}`}
                    onClick={() => setShowModalWaiters(true)}
                  >
                    <i className="uil uil-user" />
                    <span className="pay-mdl-chip-text">
                      <span className="pay-mdl-chip-key">Mesero</span>
                      <span className="pay-mdl-chip-val">
                        {selectedWaiter != null ? (selectedWaiter.user_name ?? selectedWaiter.name ?? "") : "Sin asignar"}
                      </span>
                    </span>
                  </button>
                </RenderIf>

                <RenderIf isTrue={!isPointsPayment && moduleTips == 1}>
                  <button
                    type="button"
                    className={`pay-mdl-chip ${propinaSet ? "is-set" : ""}`}
                    onClick={() => setActivePanel("propina")}
                  >
                    <i className="uil uil-coins" />
                    <span className="pay-mdl-chip-text">
                      <span className="pay-mdl-chip-key">Propina</span>
                      <span className="pay-mdl-chip-val">{propinaSet ? `$${Number(invoiceTips).toFixed(2)}` : "Sin propina"}</span>
                    </span>
                  </button>
                </RenderIf>
              </div>

              {/* ---------------- MÉTODOS DE PAGO / CANJE ---------------- */}
              <div className="pay-mdl-methods">

                {isPointsPayment ? (
                  <div className="pay-mdl-points">
                    <div className="pay-mdl-points-head">
                      <div>
                        <h4 className="pay-mdl-points-title">Canje de puntos</h4>
                        <small className="pay-mdl-points-sub">Selecciona o crea un cliente para validar sus puntos disponibles.</small>
                      </div>
                      <span className="pay-mdl-points-badge">{pointsTotal} pts</span>
                    </div>

                    {dataClientSelected == null ? (
                      <>
                        <p className="pay-mdl-note pay-mdl-note--info">
                          Busca un cliente existente o registra uno nuevo antes de finalizar el canje.
                        </p>
                        <ClientPillCard dataClientSelected={dataClientSelected} setdataClientSelected={setdataClientSelected} addressNowLocation={addressNowLocation} setAddressNowLocation={setAddressNowLocation} parthner_order={parthner_order} setShoppingCart={setShoppingCart} calculateInvoiceTotals={calculateInvoiceTotals} enabledOnlineOrder={enabledOnlineOrder} parthners={parthners} selectRestaurant={selectRestaurant} setResetData={setResetData} shoppingCart={shoppingCart} shoppingCartCombos={shoppingCartCombos} setShoppingCartCombos={setShoppingCartCombos} />
                      </>
                    ) : (
                      <div>
                        <div className="pay-mdl-client">
                          <div className="pay-mdl-line">
                            <span>Cliente</span>
                            <strong>{dataClientSelected.name || dataClientSelected.billing_name || "Cliente"}</strong>
                          </div>
                          <div className="pay-mdl-line">
                            <span>Email</span>
                            <strong>{dataClientSelected.email || "-"}</strong>
                          </div>
                          <div className="pay-mdl-line">
                            <span>Puntos disponibles</span>
                            <strong className={hasEnoughPointsForOrder(dataClientSelected) ? "pay-mdl-ok" : "pay-mdl-bad"}>
                              {getClientAvailablePoints(dataClientSelected)} pts
                            </strong>
                          </div>
                          <div className="pay-mdl-line">
                            <span>Puntos a descontar</span>
                            <strong>{pointsTotal} pts</strong>
                          </div>
                          <div className="pay-mdl-line pay-mdl-line--total">
                            <span>Restante</span>
                            <strong>
                              {Math.max(getClientAvailablePoints(dataClientSelected) - Number(pointsTotal || 0), 0)} pts
                            </strong>
                          </div>
                        </div>

                        {!hasEnoughPointsForOrder(dataClientSelected) ? (
                          <p className="pay-mdl-note pay-mdl-note--bad">
                            El cliente no tiene puntos suficientes para finalizar esta venta.
                          </p>
                        ) : (
                          <p className="pay-mdl-note pay-mdl-note--ok">
                            Cliente validado. Puedes finalizar el canje.
                          </p>
                        )}

                        <button
                          type="button"
                          className="pay-mdl-btn pay-mdl-btn--ghost pay-mdl-btn--block"
                          onClick={() => { setdataClientSelected(null); }}
                        >
                          Cambiar cliente
                        </button>
                      </div>
                    )}
                  </div>
                ) : (
                  <>
                    <h3 className="pay-mdl-section-title">Método de pago</h3>

                    {!paymentMethod.length ? (
                      <p className="pay-mdl-empty">No hay métodos de pago disponibles.</p>
                    ) : (
                      <PayScroller>
                        {paymentMethod.map(option => {
                          const optId = option.id + "payment" + option.id + option.integration.id;
                          return (
                            <article className="pay-mdl-method" key={option.id + option.integration.id}>
                              <input
                                className="pay-mdl-method-input"
                                type="radio"
                                disabled={kinposPaymentPending}
                                name="option_payments"
                                id={optId}
                                value={JSON.stringify(option)}
                                onChange={(e) => (selectPayment(e))}
                              />
                              <label className="pay-mdl-method-card" htmlFor={optId}>
                                <span className="pay-mdl-method-check" aria-hidden="true" />
                                <img
                                  loading="lazy"
                                  className="pay-mdl-method-logo"
                                  src={buildCloudinaryImageUrl({ url: option.img, width: 300, quality: "auto:good", type: "image" }) || empty_img}
                                  alt=""
                                />
                                <span className="pay-mdl-method-name">{option.payment}</span>
                                <span className="pay-mdl-method-tag">{option.integration.name}</span>
                              </label>
                            </article>
                          );
                        })}
                      </PayScroller>
                    )}
                    <h3 className="pay-mdl-section-title">Método de pago Especial</h3>

                    {enabledOnlineOrder === true ? (
                      <ModalCallCenter
                        checkDeliveryOrder={checkDeliveryOrder}
                        dv={dv} name={name} ruc={ruc}
                        setDv={setDv}
                        setName={setName}
                        setRuc={setRuc}
                        dataResponse={dataResponse}
                        optionalData={optionalData}
                        setDataResponse={setDataResponse}
                        setOptionalData={setOptionalData}
                        shoppingCart={shoppingCart}
                        shoppingCartCombos={shoppingCartCombos}
                        total={total}
                        subtotal={subtotal}
                        tax={tax}
                        discount={discount}
                        setPageLoader={setPageLoader}
                        dataPreOrder={dataPreOrder}
                        taxesArrayAll={taxesArrayAll}
                        cardGroup={cardGroup}
                        dataDicountApply={dataDicountApply}
                        paramsMicros={paramsMicros}
                        parthner_order={parthner_order}
                        dataClientSelected={dataClientSelected}
                        setdataClientSelected={setdataClientSelected}
                        addressNowLocation={addressNowLocation}
                        setAddressNowLocation={setAddressNowLocation}
                        domain={domain}
                        events={events}
                      />
                    ) : null}


                  </>
                )}
              </div>

            </div>

            {/* ---------------- FOOTER ---------------- */}
            <div className="pay-mdl-foot">
              <div className="pay-mdl-foot-total">
                <span className="pay-mdl-foot-text">
                  <span className="pay-mdl-foot-label">
                    {isPointsPayment ? "Total puntos" : invoiceTips > 0 ? "Total + propina" : "Total a pagar"}
                  </span>
                  <span className="pay-mdl-foot-amount">
                    {isPointsPayment
                      ? `${pointsTotal} pts`
                      : `$${(invoiceTips > 0 ? totaltopay : total).toFixed(2)}`}
                  </span>
                </span>

                <button
                  type="button"
                  className="pay-mdl-summary-btn"
                  onClick={() => setActivePanel("resumen")}
                >
                  <i className="uil uil-receipt" /> Ver resumen
                </button>
              </div>

              <div className="pay-mdl-foot-actions">
                <button
                  className="pay-mdl-btn pay-mdl-btn--ghost"
                  disabled={kinposPaymentPending}
                  onClick={() => {
                    // "Pagar con POS" (Mesas): este "Cancelar" es el mismo boton "X"/overlay/Escape de
                    // siempre para un cobro normal de caja, pero aqui hay ademas una solicitud del
                    // cliente esperando en la mesa - debe liberarla igual que "Cancelar solicitud" del
                    // aviso de arriba, o la mesa se queda mostrando el cobro como pendiente para siempre.
                    if (posPaymentContext?.payment_attempt_id) {
                      releasePosPaymentRequest();
                      return;
                    }
                    setShow(false);
                    localStorage.setItem("token_session", generateToken());
                    onDismiss?.();
                  }}
                >
                  Cancelar
                </button>

                <button
                  className="pay-mdl-btn pay-mdl-btn--pay"
                  disabled={kinposPaymentPending || (isPointsPayment && (pointsRedeemLoading || !dataClientSelected?.id || !hasEnoughPointsForOrder(dataClientSelected)))}
                  onClick={() => (isPointsPayment ? processPointsPayment() : processPayment())}
                >
                  {isPointsPayment
                    ? (pointsRedeemLoading ? "Canjeando..." : "Finalizar canje")
                    : kinposPaymentPending
                      ? "Procesando en KinPOS..."
                      : `Realizar Pago $${(invoiceTips > 0 ? totaltopay : total).toFixed(2)}`}
                </button>
              </div>
            </div>

            {/* ================= POPUPS DE SECCIÓN ================= */}

            <PaySheet
              open={activePanel === "resumen"}
              title="Resumen de compra"
              onClose={() => setActivePanel(null)}
            >
              {paySummaryLines}
            </PaySheet>

            <PaySheet
              open={activePanel === "localizador"}
              title="Localizador"
              onClose={() => setActivePanel(null)}
            >
              <ModuleLocator locator={locator} setLocator={setLocator}></ModuleLocator>
            </PaySheet>

            <PaySheet
              open={activePanel === "paisanitos"}
              title="Paisanitos"
              onClose={() => setActivePanel(null)}
            >
              <ModalDonlee client_phone={client_phone} setClient_phone={setClient_phone} locator={locator} setLocator={setLocator} dataClient={dataClient} setDataClient={setDataClient}></ModalDonlee>
            </PaySheet>

            <PaySheet
              open={activePanel === "propina"}
              title="Propina"
              onClose={() => setActivePanel(null)}
            >
              <ModuleTips invoiceTips={invoiceTips} setInvoiceTips={setInvoiceTips} recomendationTips={recomendationTips} setEventHandler={setEventHandler}></ModuleTips>
            </PaySheet>

          </div>
        </div>,
        document.body
      )}




      <div > {responseQr == true ? <ModalConfirmation sendStatus={sendStatus} dataClientSelected={dataClientSelected} formatDataEmail={formatDataEmail} setResponseQr={setResponseQr} orderCode={order_code} setPageLoader={setPageLoader} orderNumber={datatransaction_code} total={total} change={change} setChange={setChange} totaltopay={totaltopay} invoiceTips={invoiceTips} microsModule={microsModule} datatransaction_code={datatransaction_code} order_id={order_id} printOrder={printOrder} isPointsPayment={isPointsPayment} pointsTotal={pointsTotal} /> : ""}</div>
      {/* Modals of validation of invoice  client data on dgi */}
      {showEditBill && createPortal(
        <div className="bill-mdl-overlay" onClick={handleEditBillClose}>
          <div
            className="bill-mdl-dialog"
            role="dialog"
            aria-modal="true"
            aria-label="Personalizar factura"
            onClick={(e) => e.stopPropagation()}
          >

            {/* ---------------- HEADER ---------------- */}
            <header className="bill-mdl-head">
              <i className="uil uil-edit" />
              <h2 className="bill-mdl-title">Personalizar factura</h2>
              <button
                type="button"
                className="bill-mdl-close"
                aria-label="Cerrar"
                onClick={handleEditBillClose}
              >
                <i className="uil uil-times" />
              </button>
            </header>

            {/* ---------------- BODY ---------------- */}
            <div className="bill-mdl-body">

              {dataResponse == false ? (
                <section className="bill-mdl-card">
                  <h3 className="bill-mdl-card-title">Carga de datos</h3>

                  {optionalData == true ? (
                    <>
                      <div className="bill-mdl-readonly">
                        <span className="bill-mdl-readonly-key">RUC</span>
                        <span className="bill-mdl-readonly-val">{ruc}</span>
                      </div>

                      <div className="bill-mdl-field">
                        <label className="bill-mdl-label" htmlFor="bill-name">Nombre</label>
                        <input
                          id="bill-name"
                          className="bill-mdl-input"
                          placeholder="Nombre"
                          onChange={(e) => (setName(e.target.value))}
                        />
                      </div>

                      <div className="bill-mdl-field">
                        <label className="bill-mdl-label" htmlFor="bill-dv">DV</label>
                        <input
                          id="bill-dv"
                          className="bill-mdl-input bill-mdl-input--short"
                          placeholder="00"
                          onChange={(e) => (setDv(e.target.value))}
                        />
                      </div>

                      <div className="bill-mdl-actions">
                        <button
                          className="bill-mdl-btn bill-mdl-btn--ghost"
                          type="button"
                          onClick={() => (setOptionalData(false))}
                        >
                          Ingresar nuevo RUC
                        </button>
                        <button
                          className="bill-mdl-btn bill-mdl-btn--primary"
                          type="button"
                          onClick={() => (setDataResponse(true))}
                        >
                          Cargar datos
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="bill-mdl-field">
                        <label className="bill-mdl-label" htmlFor="bill-name-2">Nombre</label>
                        <input
                          id="bill-name-2"
                          className="bill-mdl-input"
                          placeholder="Nombre"
                          onChange={(e) => (setName(e.target.value))}
                        />
                      </div>

                      <div className="bill-mdl-field">
                        <label className="bill-mdl-label" htmlFor="bill-ruc">RUC o cédula</label>
                        <div className="bill-mdl-inline">
                          <input
                            id="bill-ruc"
                            type="text"
                            className="bill-mdl-input"
                            placeholder="0-000-000"
                            onChange={(e) => (setRuc(e.target.value))}
                          />
                          <button
                            className="bill-mdl-btn bill-mdl-btn--primary"
                            type="button"
                            onClick={() => (validDataClient())}
                          >
                            Validar{contAuthRuc > 0 ? ` (${contAuthRuc})` : ""}
                          </button>
                        </div>
                        {contAuthRuc > 0 ? (
                          <p className="bill-mdl-hint">Intento {contAuthRuc}. Verifica el número antes de reintentar.</p>
                        ) : null}
                      </div>
                    </>
                  )}
                </section>
              ) : (
                <section className="bill-mdl-card">
                  <h3 className="bill-mdl-card-title">Datos del usuario</h3>

                  <div className="bill-mdl-summary">
                    <div className="bill-mdl-row">
                      <span>Nombre</span>
                      <strong>{name}</strong>
                    </div>
                    <div className="bill-mdl-row">
                      <span>RUC</span>
                      <strong>{ruc}</strong>
                    </div>
                    <div className="bill-mdl-row">
                      <span>DV</span>
                      <strong>{dv}</strong>
                    </div>
                  </div>

                  <div className="bill-mdl-actions">
                    <button
                      className="bill-mdl-btn bill-mdl-btn--ghost"
                      type="button"
                      onClick={() => (setDataResponse(false), setOptionalData(false))}
                    >
                      Ingresar nuevo RUC
                    </button>
                    <button
                      className="bill-mdl-btn bill-mdl-btn--ghost"
                      type="button"
                      onClick={() => (setDataResponse(false))}
                    >
                      Cambiar datos
                    </button>
                  </div>
                </section>
              )}

              {/* ---------------- INFORMACIÓN ADICIONAL ---------------- */}
              <details className="bill-mdl-details">
                <summary>Información adicional</summary>

                <div className="bill-mdl-field">
                  <label className="bill-mdl-label" htmlFor="bill-address">Dirección fiscal</label>
                  <input
                    id="bill-address"
                    className="bill-mdl-input"
                    placeholder="Ejemplo: Calle, número, corregimiento"
                    value={addresDescriptionClientFiscal}
                    maxLength={90}
                    onChange={(e) => (setAddresDescriptionClientFiscal(e.target.value))}
                  />
                </div>

                <div className="bill-mdl-field">
                  <label className="bill-mdl-label" htmlFor="bill-extra">Dato adicional</label>
                  <textarea
                    id="bill-extra"
                    className="bill-mdl-input bill-mdl-textarea"
                    rows="3"
                    placeholder="Orden de compra, dirección de entrega…"
                    value={aditional_data}
                    onChange={(e) => (setAditional_data(e.target.value))}
                  />
                </div>
              </details>

              {/* ---------------- BUSCAR CLIENTE ---------------- */}
              <div className="bill-mdl-divider"><span>o busca un cliente registrado</span></div>

              <ClientPillCard dataClientSelected={dataClientSelected} setdataClientSelected={setdataClientSelected} addressNowLocation={addressNowLocation} setAddressNowLocation={setAddressNowLocation} parthner_order={parthner_order} setShoppingCart={setShoppingCart} calculateInvoiceTotals={calculateInvoiceTotals} enabledOnlineOrder={enabledOnlineOrder} parthners={parthners} selectRestaurant={selectRestaurant} setResetData={setResetData} shoppingCart={shoppingCart} shoppingCartCombos={shoppingCartCombos} setShoppingCartCombos={setShoppingCartCombos} />

            </div>

            {/* ---------------- FOOTER ---------------- */}
            <div className="bill-mdl-foot">
              <button
                className="bill-mdl-btn bill-mdl-btn--ghost"
                onClick={handleEditBillClose}
              >
                Cerrar
              </button>
              <button
                className="bill-mdl-btn bill-mdl-btn--save"
                onClick={handleEditBillClose}
              >
                Guardar datos
              </button>
            </div>

          </div>
        </div>,
        document.body
      )}



      {/* Modal Cashierpost */}
     {modalShow && createPortal(
   <div className="cash-overlay" role="dialog" aria-modal="true" aria-label="Pagos en efectivo">
      <div className="cash-dialog">
 
         {/* ---------------- HEADER ---------------- */}
         <header className="cash-head">
            {/* <span className="cash-head-title ">
               <i className="uil uil-money-bill" />
               Pagos en efectivo
            </span> */}
 
            <div className="cash-head-item">
               <span className="cash-head-label">Orden</span>
               {/* <span className="cash-head-val">{!datatransaction_code ? "0000" : datatransaction_code}</span> */}
                 <span className="cash-head-val">{!orderNumber ? "0000" : orderNumber}</span>
            </div>
 
            <div className="cash-head-item cash-head-item--due">
               <span className="cash-head-label">Monto a pagar</span>
               <span className="cash-head-val" translate="no">${amountOrder}</span>
            </div>
 
            <button
               type="button"
               className="cash-close"
               aria-label="Cerrar"
               onClick={handleCloseModal}
            >
               <i className="uil uil-times" />
            </button>
         </header>
 
         {/* ---------------- BODY + FOOTER ---------------- */}
         <Cashierpost
            setChange={setChange}
            setAmountOrder={setAmountOrder}
            setOrderNumber={setOrderNumber}
            setModalShow={setModalShow}
            order_data={detailOrder}
            statusCash={statusCash}
            paymentInfo={paymentInfo}
         />
 
      </div>
   </div>,
   document.body
)}


      {/*Process payment Loading Modal showModalProcess */}
      {/* ==================================================================
    PROCESO DE PAGO — proc-*
   
   ================================================================== */}

      {showModalProcess && createPortal(
        <div className="proc-overlay" role="dialog" aria-modal="true" aria-label="Procesando pago">
          <main className="proc-main">
            <section className="proc-card">

              {/* ---------------- EN PROCESO ---------------- */}
              <RenderIf isTrue={paymentApproval.status == 0}>
                <span className="proc-method proc-method--wait">
                  Método de pago: {paymentInfo.payment}
                </span>

                <img className="proc-icon" src={loading} width="96" height="96" alt="" />

                <h3 className="proc-title">{paymentApproval.description}</h3>

                {tempMethodPayment == 1 ? (
                  <div className="proc-actions">
                    <button className="proc-btn proc-btn--ghost" onClick={() => cancelMethodPayment()}>
                      Cancelar
                    </button>
                  </div>
                ) : ""}
              </RenderIf>

              {/* ---------------- ÉXITO ---------------- */}
              <RenderIf isTrue={paymentApproval.status == 1}>
                <span className="proc-method proc-method--ok">
                  Método de pago: {paymentInfo.payment}
                </span>

                <img className="proc-icon" src={checkimg} width="96" height="96" alt="" />

                <h3 className="proc-title">¡Éxito!</h3>
                <p className="proc-text">Su pago ha sido procesado correctamente.</p>
              </RenderIf>

              {/* ---------------- ERROR ---------------- */}
              <RenderIf isTrue={paymentApproval.status == 2}>
                <span className="proc-method proc-method--bad">
                  Método de pago: {paymentInfo.payment}
                </span>

                <img className="proc-icon" src={cancel} width="96" height="96" alt="" />

                <h3 className="proc-title proc-title--sm">{paymentApproval.description}</h3>
                <p className="proc-text">Verifique la información e intente nuevamente.</p>

                    {tempMethodPayment == 1 ? (
                  <div className="proc-actions">
                    <button className="proc-btn proc-btn--ghost" onClick={() => cancelMethodPayment()}>
                      Cancelar
                    </button>
                  </div>
                ) : ""}
              </RenderIf>

              {/* ---------------- ERROR CON REINTENTO ---------------- */}
              <RenderIf isTrue={paymentApproval.status == 3}>
                <span className="proc-method proc-method--bad">
                  Método de pago: {paymentInfo.payment}
                </span>

                <img className="proc-icon" src={cancel} width="96" height="96" alt="" />

                <h3 className="proc-title proc-title--sm">{paymentApproval.description}</h3>
                <p className="proc-text">Verifique la información e intente nuevamente.</p>

                <div className="proc-actions">
                  <button className="proc-btn proc-btn--ghost" onClick={() => (cancelTempYappy())}>
                    Volver
                  </button>
                  <button className="proc-btn proc-btn--primary" onClick={() => (try_again_yappy())}>
                    Intentar de nuevo
                  </button>
                </div>
              </RenderIf>

            </section>
          </main>
        </div>,
        document.body
      )}

      {/*input phone client */}
      <ModalPhoneSaveYappy showModalPhone={showModalPhone} setShowModalPhone={setShowModalPhone} nextStepYappy={nextStepYappy} phone={ClearPhone(client_phone)} ></ModalPhoneSaveYappy>

      {/*Modal payment manual*/}
      <ModalPaymentManual showPaymentManual={showPaymentManual} setPaymentManual={setPaymentManual} paymentInfo={paymentInfo} formatDataOrder={formatDataOrder} registernewOrder={registernewOrder} statusActivity={true}></ModalPaymentManual>

      {/*Modal error register order */}
      <Modal
        size='lg'
        show={modalShowErrorRegisterOrder}
        onHide={() => setModalShowErrorRegisterOrder(false)}
        backdrop="static"
        centered>
        <Modal.Body>
          <h1 className='text-center m-3'>Lo sentimos ocurrio un error</h1>
          <h5 className='text-center'>{txtErrorRegisterOrder !== "" ? txtErrorRegisterOrder : "La orden no pudo ser registrada"}</h5>
          <div className='d-flex alight-item-center justify-content-center'>
            <button className='m-3 btn btn-danger btn-lg' onClick={() => setModalShowErrorRegisterOrder(false)}> Cancelar </button>
            <button className=' m-3 btn btn-success btn-lg' onClick={() => getLastOrderMachineNow()}> Intentar nuevamente</button>
          </div>
        </Modal.Body>
      </Modal>

      {/** Modal to cashback */}
      <Modal
        show={cashbackModal}
        onHide={() => setCashbackModal(false)}
        backdrop="static"
        centered>
        <Modal.Body>
          <h1 className='text-center m-3'>Ingresar el monto de cashback</h1>
          <input type="text" className='form-control' onChange={e => setCashback(e.target.value)} />
          <div className='d-flex alight-item-center justify-content-center'>
            <button className='m-3 btn btn-danger btn-lg' onClick={() => setCashbackModal(false)}> Cancelar </button>
            <button className=' m-3 btn btn-success btn-lg' onClick={() => {
              //We set the cashback value to the paymentInfo object
              paymentInfo.cashback = cashback;
              //We validate the payment method to make the payment
              if (paymentInfo.integration.id == 6) {
                //We make the payment with the cashback
                requestPaymentEvertech(paymentInfo);
                setChange(0);
                //We close the modal
                setTimeout(() => {
                  setCashbackModal(false)
                  setTempMethodPayment(1);
                }, 15000);
              } else {
                ErrorAlert("", "El metodo de pago no es valido", "error");
                setCashbackModal(false)
              }
            }} > Finalizar</button>
          </div>
        </Modal.Body>
      </Modal>

      <ModalYappyQrPos modalYappyQr={modalYappyQr} setModalYappyQr={setModalYappyQr} dataYappy={dataYappy} setDataHash={setDataHash} setYappy_transaction_id={setYappy_transaction_id} dataHash={dataHash} hadleCancelYappy={hadleCancelYappy} total={total} orderNumber={orderNumber} totaltopay={totaltopay}></ModalYappyQrPos>
      <ModalPaymentMixto showModalMixto={showModalMixto}
        setShowModalMixto={setShowModalMixto}
        paymentMethod={paymentMethod}
        total={totaltopay}
        subtotal={subtotal}
        discount={discount}
        tax={tax}
        orderNumber={orderNumber}
        formatDataOrder={formatDataOrder}
        registernewOrder={registernewOrder}
        listPaymentReady={listPaymentReady}
        setlistPaymentReady={setlistPaymentReady}
        amountPaymentReady={amountPaymentReady}
        setAmountPaymenReady={setAmountPaymenReady}
        shoppingCart={shoppingCart}
        amountPending={amountPending}
        setAmountPending={setAmountPending}
        aprovedManualPaymentacardMixto={0}
        yappy_transaction_id={yappy_transaction_id}
        setYappy_transaction_id={setYappy_transaction_id}
        decimalReduction={decimalReduction}

      ></ModalPaymentMixto>
      {/**Modal of insuficient message */}
      <Modal show={showModalInsufficientFunds} onHide={() => setShowModalInsufficientFunds(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Información</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex alight-item-center justify-content-center">
            <RenderIf isTrue={insufficientMessage !== null}>
              <div>
                <pre>{insufficientMessage}</pre>
              </div>
            </RenderIf>

            <RenderIf isTrue={insufficientMessage === null}>
              <div>
                <pre>No se genero voucher</pre>
              </div>
            </RenderIf>

          </div>
          <div className='row'>
            <div className="d-flex justify-content-center">
              <button className="btn btn-info" onClick={() => setShowModalInsufficientFunds(false)}>Cerrar</button>
              <button className="btn btn-success" onClick={() => setShowModalInsufficientFunds(false)}>imprimir</button>
            </div>
          </div>
        </Modal.Body >
      </Modal >

      <ModalWaiters
        selectPreOrder={selectPreOrder}
        showWaiters={showModalWaiters}
        setShowWaiters={setShowModalWaiters}
        onConfirmWaiter={handleConfirmWaiter}
        defaultWaiterId={
          selectPreOrder?.waiter?.user_id ??
          selectPreOrder?.waiter?.id ??
          selectPreOrder?.waiter_id ??
          selectedWaiter?.user_id ??
          selectedWaiter?.id ??
          null
        }
      />

      {orderToRecovery !== null && <RecoveryOrderApproved recoveryOrderApproved={recoveryOrderApproved} setRecoveryOrderApproved={setRecoveryOrderApproved} registernewOrder={registernewOrder} orderData={orderToRecovery} setOrderToRecovery={setOrderToRecovery} preserveOrderDraft={preserveKinposRecoveryDraft}></RecoveryOrderApproved>}


    </>
  )
}

export default ModalPayMet




